// en.js
export default {
  // nav: {
  //   home: "HOME",
  //   products: "PRODUCTS",
  //   solution: "SOLUTION",
  //   about_us: "ABOUT US",
  //   contact_us: "CONTACT US",
  //   language: "LANGUAGE"
  // },
  navArr:[
    {
      title: "",
      path: "/pc/home",
      children:[],
    },
    {
      title: "PRODUCTS",
      path: "/pc/productList",
      children:[
        {
          title:'Recording and Broadcasting',
          children:[
            {
              title:'W-R01 Series',
              img:{
                path:'/pc/productList_info?ID=W-R01-Series-Portable-Recording-and-Broadcasting-Solution',
                src:'record1.png'
              }
            },
            {
              title:'W-R02 Series',
              img:{
                path:'/pc/productList_info?ID=W-R02-Series-Classroom-Recording-and-Broadcasting-Solution',
                src:'record0.png'
              }
            },
            {
              title:'W-R03 Series',
              img:{
                path:'/pc/productList_info?ID=W-R03-Series-4K-Premium-Recording-and-Broadcasting-Solution',
                src:'record2.png'
              }
            },
            // {
            //   title:'Outdoor Recording and Broadcasting',
            //   img:{
            //     path:'/pc/productList_info?ID=PECORDED_13',
            //     src:'record3.png'
            //   }
            // },
            {
              title:'W-R04 Series',
              img:{
                path:'/pc/productList_info?ID=W-R04-Series-Practical-Training-Recording-and-Broadcasting-Solution',
                src:'record4.png'
              }
            }
          ]
        },
        {
          title:'Touch Displays',
          children:[
            {
              title:'RS01 Series',
              img:{
                path:'/pc/productList_info?ID=RS01-Series-Education-IR-Touch-Display',
                src:'RS01-series.jpg'
              }
            },
            {
              title:'RS02 Series',
              img:{
                path:'/pc/productList_info?ID=RS02-Series-NEW-EDLA-Touch-Display',
                src:'RS02-series.jpg'
              }
            },
            {
              title:'RS03 Series',
              img:{
                path:'/pc/productList_info?ID=RS03-Series-AI-Integrated-IR-Touch-Display',
                src:'RS03-series.jpg'
              }
            },
            {
              title:'RS05 Series',
              img:{
                path:'/pc/productList_info?ID=RS05-SERIES-IR-Premium-Touch-Display',
                src:'RS05-series.jpg'
              }
            },
            {
              title:'PT Series',
              img:{
                path:'/pc/productList_info?ID=PT-Series-Touch-Display',
                src:'PT-series.jpg'
              }
            }
          ]
        },
        {
          title:'Intelligent Blackboard',
          children:[
            {
              title:'IBB-F01',
              img:{
                path:'/pc/productList_info?ID=IBB-F01-IR-Series-Intelligent-Blackboard',
                src:'ibb-f01.png'
              }
            },
            {
              title:'IBB-P02',
              img:{
                path:'/pc/productList_info?ID=IBB-P02-Series-Intelligent-Blackboard',
                src:'ibb-p02.png'
              }
            }
          ]
        },
        {
          title:'Smart Mobile Screen',
          children:[
            {
              title:'Smart Mobile Screen',
              img:{
                path:'/pc/productList_info?ID=Smart-Mobile-Screen',
                src:'Smart-Mobile-Screen.jpg'
              }
            }
          ]
        },
        {
          title:'Smart Lectern',
          children:[
            {
              title:'WT-01-Series',
              img:{
                path:'/pc/productList_info?ID=WT-01-Series',
                src:'desk0.png'
              }
            },
            {
              title:'WT-05-Series',
              img:{
                path:'/pc/productList_info?ID=WT-05-Series',
                src:'desk1.png'
              }
            }
          ]
        },
        {
          title:'Supporting Solutions',
          children:[
            {
              title:'Supporting Solutions',
              img:{
                path:'/pc/productList_info?ID=Supporting-Solutions',
                src:'Supporting-Solutions.png'
              }
            }
          ]
        }
      ]
    },
    {
      title: "SOLUTION",
      path: "/pc/schemeList",
      children:[
        {
          title:'4K Video Recording Classroom Solution',
          children:[],
          img:{
            path:'/pc/4k-record',
            src:'1.jpg'
          }
        },
        {
          title:'Normalized Video Recording Solution',
          children:[],
          img:{
            path:'/pc/normalized-record',
            src:'2.jpg'
          }
        },
        {
          title:'Co-teaching Classroom Solution',
          children:[],
          img:{
            path:'/pc/dual-teacher',
            src:'3.jpg'
          }
        },
        {
          title:'Portable Video Recording Solution',
          children:[],
          img:{
            path:'/pc/portable-record',
            src:'4.jpg'
          }
        },
        {
          title:'AI Behavioral Analysis',
          children:[],
          img:{
            path:'/pc/ai-behavior',
            src:'5.jpg'
          }
        },
        {
          title:'Smart Classroom Solution',
          children: [
            {
              title:'Smart Classroom Solution for High Education',
              img:{
                path:'/pc/higherEdu',
                src:'6.jpg'
              }
            },
            {
              title:'K12 All-subject Smart Classroom Solution',
              img:{
                path:'/pc/smartClasssroom',
                src:'7.jpg'
              }
            }
          ]
        },
      ],
    },
    {
      title: "ABOUT US",
      path: "/pc/about_us",
      children:[],
    },
    {

      title: "NEWS & EVENTS",
      path: "/pc/news",
      children:[],
    },
    {
      title: "CONTACT US",
      path: "/pc/contact_us",
      children:[],
    },
  ],
  foot: {
    foot_title: "GET CONNECTED WITH US",
    company: "Company",
    about_wenxiang: "AboutWenXiang",
    awards: "Awards",
    contact_us: "CONTACT US",
    news_events: "News & Events",
    blogs: "Blogs",
    customer_stories: "Customer Stories",
    input_placeholder: "Enter your E-mail Address",
    submit: "SUBMIT",
    details:
      "Sign up to receive WENXIANG marketing emails. You canmodify your subscription or unsubscribe at any time",
    web:'Web Policy',
    product:'Product Policy',
    cookie:'Cookies Policy',
    },
  home: {
    product: "PRODUCTS",
    solution: "SOLUTIONS",
    more_btn: "MORE",
    learn_more_btn:"LEARN MORE",
    product_a_title: "IBB Intelligent Blackboard",
    product_b_title: "TOUCH DISPLAYS",
    product_c_title: "RECORDING AND BROADCASTING SYSTEM",
    slogan: "Building a Beautiful Campus with Information \n Technology and Artificial Intelligence",
    solution_a_title: "4K Record and Broadcasting Classroom",
    solution_b_title: "Normalized Record and Broadcasting Classroom Construction Program",
    solution_c_title: "Co-teaching Classroom Solution",
    solution_d_title: "Portable Record and Broadcasting Construction Program",
    solution_e_title: "AI Intelligent Behavior Analysis",
    solution_f_title: "Smart Classroom Overall Solution for Higher Education",
    },
  contact_us: {
    contact_us: "CONTACT US",
    contact_details:
      "Building a Beautiful Campus with Information Technology \n and Artificial Intelligence",
    contact_BJ_title: "Beijing Wenxiang Information \n Technology Co., Ltd.",
    contact_BJ_itemA:
      "Add: 11/F, Tower B, No.15 Ronghua South Road, Beijing Economic-Technological Development Area, Beijing, China",
    contact_BJ_itemB: "Web: http://www.wenxiang.cn",
    contact_BJ_itemC: "Tel: 010-81028190/91/92/93/94",
    contact_BJ_itemD: "Service Hotline: 400-860-8282",
    contact_AH_title: "Anhui Wenxiang Technology \n Co., Ltd.",
    contact_AH_itemA:
      "Add: Intersection of Fengming Avenue and Hanjiang Road, Jiangnan Industrial Concentration Zone, Chizhou, Anhui Province, China",
    contact_AH_itemB: "Web: http://www.wenxiang.cn",
    contact_AH_itemC: "Tel: 0566-5228888",
    contact_AH_itemD: "Service Hotline: 400-860-8282"
  },
  about_us: {
    about_us: "ABOUT US",
    about_details:
      "Building a Beautiful Campus with Information Technology \n and Artificial Intelligence",
    company_profile: "Company Profile",
    BJ_company_profile_title: "BEIJING WENXIANG",
    BJ_company_profile_details:`
    Beljing Wenxiang lnformation Technology Co, Ltd. (referred to as Beijing Wenxiang) is an information technology companyspecializing in video and audio acquisition and transmission, image recognition and deep learming, big data mining and application. Among them, the core technologies of intelligent recording and broadcasting and teaching behavior identifcation andanalysis independently developed by Wenxiang are at the international leading level.At present,Wenxiang has obtained 316 authorized patents and has 252 software copyrights. As a technological innovation enterprise, Wenxiang has always adhered to the source of core technology innovation, and its hardware and software integrated inteligent products have been widely used in the field of education informatization, providing perfect and high-quality solutions for education. The main products include automatic recording and broadcasting system, teaching behavior identifcation and analysis system, smart management system, intelligent teaching system, education big data platform. Adhering to the purpose of Use IT and l to Build a Better Campus, Beling Wenxiang is wiling to work together with our partnersto make contributions to the realization of education balance and education informatization with more cuting-edge technology.more advanced products and better services.`,
    AH_company_profile_title: "ANHUI WENXIANG",
    AH_company_profile_details:
      "Anhui Wenxiang Technology Co.,Ltd. (referred to as Wenxiang) is an education information technology enterprise with core intellectual property rights that is committed to promoting the in-depth integration of information technology and education and teaching, and bringing the new generation of information technology and artificial intelligence to every teacher and student, every classroom and school, so that information technology can serve for a better education, and education can promote the continuous development of information technology. Wenxiang has successively set up several branches around the world.Focusing on the overall solutions of intelligent campuses, Wenxiang taking the lead to  the development of ecological chain cluster [Wenxiang Intelligent Industrial Park], can drive hundreds of enterprises to move in, the main positioning of information technology, artificial intelligence, big data, Internet of Things and other emerging industries in the education industry, and gradually form a national intelligent education demonstration base of education informatization, education intelligence and other industrial aggregation."
  },
  productList: {
    title_A: "OUR PRODUCTS",
    title_B: "RECORDING & BROADCASTING",
    WIS_DList: [
      "Normalized Record and Broadcasting Equipment",
      "Record and Broadcasting Equipment",
      "4K Premium Recording & Broadcasting",
      "Outdoor Record and Broadcasting Equipment",
      "Practical Training Recording and Broadcasting"
    ],
    title_C: "TOUCH <br/>DISPLAYS",
    whiteBoardList: ["Interactive Education Display","Conference Interactive Display"],
    title_D: "INTELLIGENT BLACKBOARD",
    blackBoardList: ["W-IBB Series Intelligent Blackboard","Dual-screen Smart Blackboard"],
    title_E: " SMART <br/> LECTERN",
    platformList: ["Smart Lectern", "Electric Smart Lectern"]
  },
  product_info: {
    title_A: "OVERVIEW",
    title_B: "FEATURES",
    title_C: "PRODUCT MODELING",

    A_A: {
      title_A: "Normalized Record and Broadcasting Equipment",
      title_A_txt: "HD Multi-touch Screen Built-in Hard Disk.",
      CPJS_txt: ` Wall-mounted design and industrial-grade embedded high-performance video and audio
        processing chip. 17.3” HD multi- touch screen with built -in hard disk, realizing recording,
        live broadcasting and interactive.
      `,
      WIS_DList: [
        {
          name: "POE Power Supply",
          conters:
            "Supporting multi-channel POE camera access and integrating power supply, control, and video transmission."
        },
        {
          name: "Touch Control",
          conters:
            "Adopting 17.3” touch LCD screen design with full touch control and video control management."
        },
        {
          name: "Resource Sharing",
          conters:
            "External USB storage devices can be connected, and courseware videos can be copied directly from the portable record and broadcasting equipment. Remote WEB download operations are supported."
        },
        {
          name: "Security and Protection",
          conters:
            "Embedded system and functional software cannot be accessed, modified, deleted or added to any other program by any person or program, avoiding any system damage caused by any wrong operation, and there is no risk of network virus infection"
        }
      ]
    },
    A_B: {
      title_A: "Portable Record and Broadcasting Equipment",
      title_A_txt: `15.6” HD touch screen can realize real-time monitoring
      andbroadcasting control, which is easy to operate.`,
      CPJS_txt: ` 4G/5G and WiFi network supports online live broadcasting at anytime
        and anywhere. Professional-grade wireless module can automatically
        pair wireless cameras after startup with strong transmission. Built-in
        battery make it more portable to use, and can be quickly set up
        recording and broadcasting scenes.
      `,
      WIS_DList: [
        {
          name: "AI tracking algorithm achieves automatic tracking"
        },
        {
          name: "Built-in AI behavior analysis"
        },
        {
          name: "The touch screen adopts full lamination AG+AF process."
        },
        {
          name:
            "LCD screen with high brightness can meet indoor and outdoor recording needs."
        }
      ]
    },
    A_C: {
      title_A: "4K Record and Broadcasting Equipment",
      title_A_txt: `ingle board design, no delay broadcasting, and multiple
       concurrent remote control.
        `,
      CPJS_txt: `Wenxiang 4K record and broadcasting equipment adopts single-board
        embedded architecture and ARM+DSP+Linux operating system, which is
        stable and reliable. Completely separating from the Windows system, it
        make users have no worry about whether Microsoft's operating system
        will stop updating or be attacked by other viruses. The system
        integrates video and audio collection, remote broadcast guidance,
        online live broadcast, online on-demand broadcast, interactive
        teaching, 4K recording and other functions. In response to the
        national call for energy conservation and environmental protection,
        Wenxiang 4K record and broadcasting equipment adopts low-voltage DC
        power supply, low energy consumption, and low heat to ensure safe and
        reliable teaching activities.
      `,
      WIS_DList: [
        {
          name: "Interactive Teaching",
          conters: `
          Support RTSP/H.323/SIP and other multi-protocol interaction
          `
        },
        {
          name: "4K UHD Recording",
          conters: `
          4K UHD video recording. Supporting 4K UHD picture synthesis and recording.
          `
        },
        {
          name: "Remote Guidance",
          conters: `
          SSupporting online broadcasting, including multi-channel real-time preview, special effects, screen splicing,
          camera control and other remote guidance.
          `
        },
        {
          name: "Customized Modification",
          conters: `
          Supporting course information, subtitles, titles, and end information. Supporting setting subtitles to enhance the appeal of courseware.
          `
        },
        {
          name: "Multiple Recording Modes",
          conters: `
          Supporting fully automatic, manual, and semi-automatic control methods, realizing single-stream single-screen (movie mode),
          single-stream multi-screen, multi-stream multi-screen (resource mode) and other recording modes.
          `
        },
        {
          name: "Security and Protection",
          conters: `
          Embedded system and functional software cannot be accessed, modified, deleted or added to any other program by any person or program,
          avoiding any system damage caused by any wrong operation, and there is no risk of network virus infection.
          `
        }
      ]
    },
    A_D: {
      title_A: "Outdoor Record and Broadcasting Equipment",
      title_A_txt: `Localization Design Built-in 17.3” Touch Screen One-key Recording.
        `,
      CPJS_txt: `Military localization portable recording and broadcasting equipment
        with Phytium motherboard and Kylin domestic system can meet the
        bidding parameters of localization. Portable design with 4 universal
        wheels is convenient to use.
      `,
      WIS_DList: [
        {
          name: "Domestic Design",
          conters: `
          Phytium motherboard and Kylin domestic system can meet the
          bidding parameters of localization.
          `
        },
        {
          name: "Portable Design",
          conters: `
          With four universal wheels, the equipment is convenient to use. When the equipment is placed horizontally,
          the wheels can be collected; And after opening the tripod, the product can be placed horizontally.
          `
        },
        {
          name: "Portable Power Supply",
          conters: `
          The power supply is independent and it can be charged on the hose or can be charged separately.
          `
        },
        {
          name: "Dual-screen Design",
          conters: `
          Office and audio/video application don’t interfere with each other. When users use KyLin System office software,
          the recording and broadcasting can normally use the audio/video recording, live broadcasting, screen switching and other functions.
          `
        }
      ]
    },
    A_E: {
      title_A: "Training Record and Broadcasting Equipment",
      title_A_txt: `New Model of Demonstration Teaching Integration of Production and
        Teaching.It helps the construction of teachers and concentrates on
        the improvement of students.
        `,
      CPJS_txt: `The whole training movable car is made of sheet metal profile
        material, and equipped with high-quality silent universal wheel at the
        bottom, which can be moved freely to teach. And the recording and
        broadcasting equipment can be hidden and installed in the box.
        Removable battery ensures long hours of teaching and three cameras can
        record the details of teaching. High integration of hardware and
        software is suitable for a variety of teaching scenarios.
      `,
      WIS_DList: [
        {
          name: "Triple-view Design",
          conters: `
          Triple-view design records the teaching close-up picture and full view, and students’ full view in the practical training system.
          `
        },
        {
          name: "Sound Reinforcement",
          conters: `
          Built-in 30W high-quality speaker cooperates with the teacher pickup can make real-time expansion of teaching voice.
          `
        },
        {
          name: "Ultra-long Battery Life",
          conters: `
          High quality power supply with replaceable disassembly design can provide a strong guarantee for continuous teaching.
          `
        },
        {
          name: "Screen Linkage",
          conters: `
          It supports the screen to connect to smart blackboard, interactive intelligent display and other display
          devices to solve the pain points in traditional teaching and focus on the important points.
          `
        }
      ]
    },
    B_A: {
      title_A: "Interactive Education Display",
      title_A_txt: ` High-definition, Simple and Powerful, Stable and Reliable.
        `,
      CPJS_txt: `Wenxiang new dual-system education display has a unique and simple
        appearance. It has a powerful quad-core chip and a built-in UHD
        large-view camera. Ultra-thin infrared touch design can deeply
        integrate with Wenxiang teaching software, realizing a smoother and
        more efficient teaching.
      `,
      WIS_DList: [
        {
          name: "4K HD Image",
          conters: `
          High brightness make the images more natural, clearer and more transparent.
          `
        },
        {
          name: "HD Camera",
          conters: `
          4K ultra-high-definition(UHD) camera with 13M pixels and wide viewing angle make clear and delicate images.
          `
        },
        {
          name: "Quad-core Upgraded",
          conters: `
          Equipped with quad-core 1.9G HZ chip and Android11.
          `
        },
        {
          name: "Interface Cover Design",
          conters: `
          The interface cover protects the equipment effectively from dust and damage.
          `
        },
        {
          name: "TYPE-C Interface",
          conters: `
          Integrating power supply, data transmission and other functions, the type-c interface saves the
          cumbersome connection steps and easily realizes many functions, which is convenient and fast.
          `
        },
        {
          name: "Comprehensive Management and Control",
          conters: `
          Touch lock, screen lock, USB lock and application lock are provided for effective protection for device security.
          `
        }
      ]
    },
    B_B:{
      // 会议交互平板
      title_A: "Conference Interactive Display",
      title_A_txt: `Efficiently Record Smart Office  Experience Beauty of Technology`,
      CPJS_txt: `Conference interactive display integrates projector, electronic whiteboard, TV, advertising machine, audio in one and it has writing, annotation, remote video conference, screen transfer and other functions, effectively improves conference efficiency. The display is often used in government, enterprises and institutions, companies, factory conference rooms, media studios, education and training institutions, exhibition halls and other places.`,
      WIS_DList: [
        {
          name: "Multi-touch",
          conters: `ultra-thin and ultra-narrow infrared design more than 20 touch points make accurate writing`
        },
        {
          name: "HD Camera",
          conters: `13MP with wide viewing angle remote pickup`
        },
        {
          name: "Core performance upgrade",
          conters: `quad-core processor Android 11.0`
        },
        {
          name: "Multiple Software Applications",
          conters: `annotation, screen-share, and writing are all contained`
        },
      ]
    },
    C_A: {
      title_A: "5PLUS Smart Blackboard",
      title_A_txt: `  Ultra-thin Design HD Display Seamless Switching.
        `,
      CPJS_txt: `Wenxiang new generation smart blackboard uses ultra-thin anti-glare
        tempered glass to reduce the interference of ambient light and
        improves the clarity of the picture. Built-in "eye care +" mode can
        effectively reduce the effect of blue light and eye fatigue, which
        protects the eyes health. Upgrade quad-core chip makes the system
        smooth significantly improved. And optional HD camera and multi-array
        microphone can achieve all-round teaching. Seamless switching between
        traditional chalkboard and smart blackboard make teachers teach more
        smoothly and more efficient, bringing a new teaching experience.
      `,
      WIS_DList: [
        {
          name: "4K HD Image",
          conters: `
          High brightness make the images more natural, clearer and more transparent.
          `
        },
        {
          name: "Core Upgraded",
          conters: `
          Equipped with a quad-core 1.9G HZ chip and Android11 operating system make the system more smooth.
          `
        },
        {
          name: "2.1 Stereo Speakers",
          conters: `
          2.1 sound channel ensures sound quality clearer and more extraordinary.
          `
        },
        {
          name: "Seamless System Connection",
          conters: `
          Windows and Android operating system can realize quick inter-transmission between files and applications. Both can be added to the desktop
          `
        },
        {
          name: "Enriching Desktop Components",
          conters: `
          It supports quickly add and delete widgets, including weather, greetings, calendars, daily words and more.
          `
        },
        {
          name: "Eye-protection+ Mode",
          conters: `
          New paper-like screen can effectively reduce the eye stimulation and eyesight damage from the electronic equipment, making eyes more comfortable.
          `
        },
        {
          name: "All-round Control",
          conters: `
          It provides effective protection for the security of the equipment by setting the touch, screen, USB and application function.
          `
        },
        {
          name: "HD Camera + Array Mic (optional)",
          conters: `
          13M pixels and wide viewing angle make clear and delicate images. 8 array microphones ensures  every corner of the classroom can record clearly.
          `
        },
        {
          name: "New Doc-scanner (optional)",
          conters: `
          New upgraded 13M HD pixel doc-scanner ensures flexible deployment and efficient teaching.
          `
        }
      ]
    },
    C_B: {
      // 双屏智慧黑板
      title_A: "Dual-screen Smart Blackboard",
      title_A_txt: `Multimedia Integration Education Supports Customization`,
      CPJS_txt: `Smart blackboard is a multimedia integrated teaching platform that perfectly combines traditional blackboard with intelligent teaching system, projector, electronic whiteboard, 4K HD large-screen TV, computer, power amplifier , visualizer (document scanner) and other technologies.
      Various splicing mode can be made according to the scene environment, mainly double splicing. Supports various splicing methods according to the site environment and the double splicing are popular.`,
      WIS_DList: [
        {
          name: "Convenient Design",
          conters: `Separate detachable OPS computers facilitate later upgrades and maintenance.`
        },
        {
          name: "Safe and Eye-protection",
          conters: `4mm tempered glass with round corner aluminum profile edge prevent teachers and students from bumping. It also effectively filters blue light and protects the eyesight. `
        },
        {
          name: "One-click Switch",
          conters: `One button can realize the switch between the chalking writing and touch display. The chalk writing is smooth and the touch operation is sensitive with 4K HD display.`
        },
        {
          name: "Rich Front Interfaces",
          conters: `Dual-channel USB, Android and OPS can be called at any time. HD speakers make excellent sound. And there are rich system function buttons. `
        },
        {
          name: "Wireless IoT",
          conters: `Wireless WIFI signal transmission module supports WIFI hotspot setting and makes it convenient for mobile phones and other wireless devices to connect and interact. The reserved RS232 interface is convenient for the school to make remote control of equipment switching on and off and other operations.`
        },
      ]
    },
    D_A: {
      title_A: "Smart Lectern",
      title_A_txt: `Ergonomic Design Built-in 23.8” 10-point Capacitive Touch Screen
        One-key Control.
        `,
      CPJS_txt: `The main body of the lectern is made of cold-rolled steel plate. The
        desktop is made of anti-static material, which has the characteristics
        of wear resistance, moisture resistance, fire prevention and
        anti-bacteria. The overall streamlined design guarantees
        anti-collision, beauty and simplicity.
      `,
      WIS_DList: [
        {
          name: "High-quality Desktop",
          conters: `
          Anti-static material makes the product wear-resistant, moisture-resistant, fire-proof and anti-bacteria.
          `
        },
        {
          name: "Large Spare Space",
          conters: `
          The mounting position is reserved for 19” equipment.
          `
        },
        {
          name: "Observation Window",
          conters: `
          The observation window of the computer mainframe is reserved on the lectern, so that the computer could be
          switched on and off normally without opening the case.
          `
        },
        {
          name: "easy teaching",
          conters: `
          The tilting design of the teaching screen displays provides the best angle of view to show the teaching content.
          The teacher stands at an appropriate position, improving the teaching efficiency.
          Real-time linkage between large and small screens make teaching more easier.
          `
        }
      ]
    },
    D_B: {
      title_A: "Electric Smart Lectern",
      title_A_txt: `Integrating split-screen teaching system, Wenxiang intelligent
        control system, record and broadcasting system, interactive system,
        tracking system and audio processing system, Wenxiang electric
        lectern can easily realize smart teaching.
        `,
      CPJS_txt: `Smart lectern adopts a three-stage design with aluminum alloy profiles
        as the main body and the surface is treated by sandblasting and
        anodizing process, showing a sense of fashion and technology. The
        lectern integrates control system, record and broadcasting system,
        interactive system, tracking system, and audio processing system to
        easily realize smart teaching.
      `,
      WIS_DList: [
        {
          name: "Multi-screen Linkage Teaching",
          conters: `
          Equipped with high-resolution(HD) electromagnetic dual-mode touch screen and adjustable display screen,
          the equipment can realize real-time linkage between large and small screens which can make teaching more easier.
          `
        },
        {
          name: "Smart IOT System",
          conters: `
          The 10.1” central control panel can control various terminal devices in the classroom, realizing real-time
          control of recording, broadcasting, interaction and live broadcasting.
          `
        },
        {
          name: "Multifunctional Design",
          conters: `
          Hidden goose-neck microphones, visualizer, and flip-type multi-function table sockets increase space
          utilization and improve teachers' teaching efficiency.
          `
        },
        {
          name: "High Integration",
          conters: `
          The central column door design is convenient for equipment installation and maintenance, and it is
          equipped with a safety lock to ensure safety. The drawer-type cabinet design at the bottom can place
          record and broadcasting equipment hosts, tracking equipment, etc. in it.
          `
        }
      ]
    }
  },

  // 方案
  // 主页
  homepage: {
    title: "WE OFFER SOLUTIONS",
    list: [
      {
        title: "4K Video Recording Classroom Solution",
        introduce: []
      },
      {
        title: "Normalized Video Recording Solution",
        introduce: []
      },
      {
        title: "Co-teaching Classroom Solution",
        introduce: []
      },
      {
        title: "Portable Video Recording Solution",
        introduce: []
      },
      {
        title: "AI Behavioral Analysis",
        introduce: []
      },
      {
        title: "Smart Classroom Solution",
        introduce: [
          'Smart Classroom Solution for High Education <br/> K12 All-subject Smart Classroom Solution',
        ]
      }
    ]
  },

  // 三个课堂
  three_classRoom: {
    title: "FEATURES AND ADVANTAGES",
    titleOne: "THREE-CLASSROOM",
    titleTwo: "SOLUTION",
    appTitle: "APPLICATION PACKAGE",
    content:
      "The program is suitable for a variety of Program application scenarios such as cross-regional interactive teaching activities, co-construction and sharing of high-quality course resources.",
    contentTwo:
      "This solution is suitable for a variety of scenarios such as sharing master teacher resources, forming online teaching and research, teaching level assessment, teaching observation and evaluation, and educational outreach.",
    contentThree:
      "This solution is suitable for a variety of scenarios such as setting up a famous school online classroom portal, synchronous courses, thematic courses, school-specific courses and realizing the display of high-quality courses.",
    synopsisOne:
      "Classroom-to-classroom online construction solution is based on the county and district, giving full play to the radiation role of urban central schools. And it promotes a variety of teaching and teaching and research organization models, helps schools to conduct the state-prescribed curriculum with totally determination, and promotes the fair and balanced development of education.",
    synopsisTwo:
      "To give full play to the role of special-grade teachers, provincial and municipal subject leaders and leading teachers, this solution uses the Wenxiang’s Full-time Education Cloud Platform to help more teachers in the provinces, cities to conduct a series of teaching and research activities. And it will help teachers to break through the bottleneck of professional development and improve the overall quality of education and teaching in schools.",
    synopsisThree:
      "There is an experimental school including schools affiliated to provincial universities, municipalities and key county schools, and it will be set as the teaching subjects. The schools concerned will draw up lesson recording plans, set up recording systems and organize excellent teachers to produce online lessons at the same time. After the reviewing of subject contents and recording technology, high-quality resources will be widely shared.",
    list: [
      "Classroom-to-classroom Online Construction Program",
      "Teacher-to-teacher Online Construction Program",
      "School-to-school Online Construction Program"
    ],

    functionList: [
      "Intelligent Course Recording",
      "Online Remote Live Broadcasting",
      "Two-way Distance Interactive Teaching",
      "Multi-board Writing and Screen Interaction",
      "Visual Management and Remote Guidance",
      "Data Statistics"
    ],

    functionListTwo: [
      {
        title: "Conducting Diversified Web-based Teaching and Research",
        name:
          "With master teachers as the core, we make full use of their resources and vigorously carry out the 1+N application to solve the shortage of outstanding teachers and achieve the sharing of quality educational resources in the region."
      },
      {
        title: "Online Remote Live Broadcasting",
        name:
          "Through the demonstration effect of master teachers, network interactive teaching, excellent lesson recording and remote training can be carried out to realize the network-helping teaching activities. Using the master teachers recorded courses with high-quality at the same time for other classrooms to study and observe the course, which gives full play to the leading role of master teachers."
      },
      {
        title: "Accessibility",
        name:
          "Through the integrated design of teaching, research and training, teachers are helped to carry out teaching and research on the practical problems they encounter in the teaching process, and to reflect on and re-practice their teaching, so as to improve their teaching standards."
      }
    ],

    functionListThree: [
      {
        title:
          "Conducting Public Classroom Activities to Promote Student-led Learning",
        name:
          "By creating a space for high-quality resources, students can selectively participate according to their own situation and learn in fragments. Online classes can build independent learning channels for students."
      },
      {
        title:
          "Expanding the Utilization of High-quality Resources and Exemplary Effect of Prestigious Schools",
        name:
          "The recording system can realize the standardized recording of daily teaching audio and video data combined with digital teaching materials, which are processed to form high-quality lessons and micro-lessons that teachers can upload and share on the school resource management platform. It helps schools to deposit high-quality educational resources, complete the construction of school-based resources, expand the utilization rate of high-quality resources and bring into play the demonstration effect of prestigious schools."
      },
      {
        title: "Promoting Personalized Development of Students",
        name:
          "Once completed, the online classroom can be opened to the public to create a high-quality curriculum with high-quality resources from the region's famous schools. It definitely thus builds a self-learning channel for students, facilitates fragmented and independent learning and promotes their personalized development."
      }
    ]
  },

  // 中小学全学科智慧教室建设方案
  mediumSchool: {
    title:
      "K12 ALL-SUBJECT SMART CLASSROOM CONSTRUCTION PROGRAM",
    content:
      "Wenxiang Smart Classroom is an innovative classroom with service teaching as the core. It is a set of solutions that realize all-media, all-coverage, all-linkage and interactive integration. It covers all teaching links during the teaching process, and it also can optimize teaching content, promote classroom interaction, and get convenient access to teaching resources. At the same time, it has the situational awareness and can take environmental intelligent management and control, achieving a healthy, intelligent, environmentally friendly and efficient new classroom teaching mode.",
    componentsTitle:'PROGRAM COMPONENTS',
    components:[
      'smart blackboard','smart lectern','recording system','learning behaviour analysis system','smart management','integrated design'
    ],
    features_title:'FEATURES AND ADVANTAGES',
    featuresList: [
      {
        title: "Smart Blackboard",
        name:'Wenxiang smart blackboard integrates traditional blackboard, intelligent teaching system, multi-touch, HD LCD display, amplifier, speaker and other technologies. Through the five-finger screen technology, teachers can easily switch seamlessly between the traditional blackboard and the interactive display system, complete ordinary blackboard writing, electronic whiteboard interaction, teaching resource invocation, multimedia courseware demonstration and other operations.'
      },
      {
        title: "Anti-glare and Eye-protection",
        name:'The surface of the glass adopts nano-composite coating technology to filter the harmful light source and effectively protect the eyesight of teachers and students.'
      },
      {
        title: "Dual OS",
        name:"Windows and Android dual system and rich teaching Program application software."
      },
      {
        title: "Multimedia Teaching",
        name:'It comes with interactive whiteboard software and multimedia teaching resources, supporting video, music, pictures, PPT and other multimedia teaching materials.'
      }
    ],
    automatic: {
      title: "Automatic 4K Record and Broadcasting System",
      name:'The classroom contains a fully automatic six-camera recording system, which supports the filming and recording of multiple video channels, including teacher close-ups and full views, student close-ups and full views, writing close-ups and student patrol pictures. All shoots are in high quality, achieving true full HD recording. It also supports access to computer signals for recording. The student walk-through function allows you to take close-ups of each student in real time, forming student behaviour data for later analysis.'
    },
    longEssay: [
      {
        title: "Smart Electronic schoolbag",
        name:
          "It is based on education cloud services and applications, and equipped with smart blackboard, student smart learning terminals and PAD smart classroom system, smart schoolbag can achieve a simple, practical and efficient smart classroom. Teachers can design interactive, collaborative, independent and other diverse classrooms according to the learning statistics of pre-lessons. Teachers can flexibly design the functions of classroom interaction and monitor real-time learning status of students. Also, teachers can interact with classroom materials and questions, reaching question-answering in real time, and provide targeted explanations and comments. The system focus on process assessment and the ability and attitude of students’ learning, motivates them to learn, reduces their stress, develops positive learning attitude and improves their performance."
      },
      {
        title:
          "Interactive classroom and pre-class cloud preparation seamlessly integrated",
        name:
          "Before class, teachers can easily prepare lessons using the precise resources in the Education Cloud platform, and send the preparation content to the class that needs to be taught with a single click, and get the preparation materials directly from the cloud after logging into the account during class. It also supports teachers to upload preparation resources to the classroom computer in advance, so that classes can be held normally based on the classroom when the external network is unstable or not available. And it doesn’t need to add additional storage devices in the classroom."
      },
      {
        title:
          "One-click question distribution and real-time results evaluated",
        name:
          "Teachers can distribute questions in real time in the classroom, and students receive the questions and choose their answers to submit. The answering situation will be showed to the teachers’ side, including the number of answers, the average correct rate, the distribution of answers, and the details of students' answers."
      },
      {
        title:
          "Real-time monitoring of students' learning process and comprehensive control of students' learning status",
        name:
          "Teachers can use the monitoring function to monitor the learning status of all students in real time. Users can see if the student is online, if it is muted, and can check the current screen information of the student's pad and compare and monitor multiple students' screens at the same time."
      },
      {
        title: "Classroom evaluation",
        name:
          "Teachers can manage current class members individually and in groups, giving multidimensional evaluations to groups or individuals at any time."
      },
      {
        title:"Classroom report",
        name:"A full classroom report is automatically generated, including the percentage of correct knowledge of the lesson, the percentage of correct questions for each question in the classroom exercise, the distribution of options, etc., to help review the content of the lesson."
      },
      {
        title: "Quantifying teaching quality",
        name:"Supervising teachers and students. Integrating online learning space and offline classroom learning space to provide a full range of teaching data analysis services. Helping teachers and researchers to understand the details of teaching and learning, to keep up to date with teaching dynamics and to quantify accurately the quality of classroom teaching. "
      }
    ],
    smartOne: {
      title: "SMART MANAGEMENT SYSTEM"
    },
    smartListOne: [
      {
        title: "Smart Attendance",
        name:
          "Based on deep learning algorithms, the system detects faces in images and performs a series of face-related feature analysis, recognizing multi-dimensional face information including name, position, clock-in time, expression and so on. The system can automatically generate attendance summary reports. For example, the number of people present, the number of people actually present, attendance statistics analysis, etc."
      },
      {
        title: "Intelligent learning analysis",
        name:
          "The system supports AI technology and provides real-time insight into changes in the teaching scene. It can automatically capture and analyse the behavioral activities of students in the room, including the recognition of basic movements and combinations of movements such as head-down, hand-up, head-twist and turn-back, and automatically generate reports. For example: number of hands-raised, number of heads-down, statistical analysis, etc. Through the analysis of classroom student behavior, teachers can understand the learning status of students, improving the development of personalized teaching in schools from single to multiple, closed to open."
      },
      {
        title: "Smart Equipment Control",
        name:'The central control management platform provides remote control, information collection, data analysis, data monitoring, data statistics and fault alarm functions.'
      },
      {
        title: "Centralized Equipment Management and Statistical Analysis of Data",
        name:"Through the Wenxiang Smart Data Platform, the operating status of information equipment in many classrooms can be visually checked and analyzed, including checking multimedia teaching equipment, recording equipment and other information equipment, and visualizing and managing data such as the number of times the equipment is used, the length of time it is used and the area in which it is distributed."
      }
    ],
    countentBox: "Intelligent Environmental Control System",
    countent: [
      {
        name:"Intelligent Eye-protection Lighting Environmental Control System: In order to comprehensively strengthen the prevention and control of myopia in teenagers, the system can recognize the light changes in the space. It will automatically adjust the power of the equipment to ensure that the system runs in the best state and ensure that teachers and students have classes in the healthiest light environment."
      },
      {
        name:"Smart Temperature and Humidity Control System: Based on the real measurements of the environment and the set target parameters, the air conditioning or fan operation is automatically adjusted to control the temperature and humidity of the environment, ensuring a healthy and comfortable environment in the classroom at all times."
      },
      {
        name:"Intelligent Air Quality Control System: The system is mainly composed of CO2 intelligent sensing module, PM2.5/PM10 intelligent sensing module, intelligent cabinet fresh air system and environmental intelligent control terminal, etc. The system solves all aspects of air quality problems in the classroom to ensure the air quality."
      }
    ],
    k12OrHigherEdu: [
      'K12 All-subject Smart Classroom Solution',
      'Smart Classroom Solution for High Education',
    ],
  },

  //智能录制和广播解决方案
  intelligentRecord: {
    title:
      "BUILDING A BEAUTIFUL CAMPUS WITH INFORMATION TECHNOLOGY AND ARTIFICIAL INTELLIGENCE",
    titleOne: "INTELLIGENT RECORD AND BROADCASTING",
    titleTwo: "SOLUTION",
    bottomBox: "APPLICATION PACKAGE",
    threeBox:
      "The essence of micro-teaching course production is described in short, small, precise and professional.",
    easeTitle: "EASE OF USE",
    easeCount:
      "Ease of use is comprehensive and multi-layered. It can be segmented into user roles for a perfect experience.",
    bottomTitle:
      "The case consists of record and broadcasting equipment, image tracking all-in-one equipment, camera, smart blackboard, audio acquisition system, recording and broadcasting control system, teaching resource management platform and other products.",
    bottomTwoTitle:
      "The program is widely used in a variety of applications such as record and broadcasting classroom resource construction, teaching quality assessment, classroom monitoring system, safe campus and so on.",
    bottomThreeTitle:
      "This solution is widely used in a variety of application scenarios such as micro-class production, flipped classroom, and mobile learning.",
    bottomFourTitle:
      "This solution is applied to a variety of application scenarios such as the construction of teaching resources in schools, the promotion of teacher-student communication, and the balanced development of high-quality educational resources.",
    synopsis:
      "The 4K record and broadcasting classroom is built for recording high-quality courses, which can well reflect the unique teaching methods and advanced education concepts of the teachers. The system adopts multi-camera shooting to intelligently track and switch the video images of teachers teaching, students listening to lectures, teacher-student interaction scenes and classroom blackboard content. It is effective and necessary to create and disseminate excellent courses by recording classroom activities.",
    synopsisTwo:
      "The program supports the construction of teaching video resources by means of information technology, realizes large-scale cross-platform interaction, live broadcasting, on-demand and other Program applications. And it has centralized management, remote control, online course patrol and other functions, enhancing the utilization rate and coverage of information teaching equipment. It also can help schools to carry out teaching work such as making teaching video courses, evaluating teachers' teaching ability, remote observation, comments and academic exchanges, teaching research and helping and assisting teaching, which can let more excellent teaching resources be made and shared together.",
    synopsisThree:
      "Micro-teaching refers to the whole process of teaching around single or multiple knowledge points in the teaching process recorded by video as the main carrier. The classroom video clips and other auxiliary teaching resources related to the teaching theme including teaching design, materials, teaching reflections, practice tests, student feedback, teacher comments, consist its core components of micro-class. The whole contents organizes and presents in a certain way to create a semi-structured, simple and They are organized and presented in a certain way to create a semi-structured, simple and thematic small environment for the application of knowledge units.",
    synopsisFour:
      "At present, China is comprehensively promoting Internet+education mode, relying on the advantages of the Internet and other information technology, innovating school twinning support mechanism, and promoting the common construction and sharing of high-quality educational resources, to expand the radiation of high-quality educational resources, and realize the management of mutual aid schools, teaching and research, resource sharing, information sharing, teacher-student interaction, and complementary differences. At the mode, there are two teachers. One lecturer teacher teaches online, the other teacher manages students on site in the classroom on the listening side offline. This teaching mode gives full play to the advantages of both online and offline teachers and effectively improve the classroom efficiency and teaching quality, enabling students from different regions to enjoy the same quality education resources. Now, the remote dual-teacher classroom solution has been well received by schools and training institutions.",
    synopsisFive:
      "The rapid development of the Internet, AI, big data, 5G and other technologies has brought significant impact on education and teaching. Wenxiang is actively applying new information technology to innovate teaching organization mode, improve learning environment, develop digital education resources, accelerate the construction and application of intelligent learning environment, enhance the innovative ability of informationized teaching, and promote the deep integration of information technology and teaching. Based on this, Wenxiang launched a portable record and broadcasting construction solution, which adopts full wireless transmission technology and can be set up in 3 minutes, so that recording and broadcasting can be truly mobile and no longer restricted by the site environment. It realizes high-quality course resource production and relay, academic video presentation and conference, large-scale live streaming of course video, and distance education, and etc..",
    list: [
      "4K RECORD AND BROADCASTING CLASSROOM CONSTRUCTION PROGRAM",
      "NORMALIZED RECORD AND BROADCASTING CLASSROOM CONSTRUCTION PROGRAM",
      "PORTABLE RECORD AND BROADCASTING CONSTRUCTION PROGRAM",
      "MICRO-TEACHING ROOM CONSTRUCTION PROGRAM",
      "REMOTE DUAL-TEACHER CLASSROOM CONSTRUCTION PROGRAM"
    ],

    featuresList: [
      {
        title: "Safe and Stable",
        name:
          "All core devices are all adopts built-in DSP+ARM design based on Linux system, which has the characteristic of high stability, low consumption and maintenance-free."
      },
      {
        title: "Fully Automated Operation",
        name:
          'It supports automatic image tracking and screen switching, which lets the teacher focus on the teaching itself. The teacher can start classroom recording by "one-click". HD shooting, and professional audio acquisition and processing helps the entire teaching process for HD recording.'
      },
      {
        title: "AI Technology",
        name:
          'Based on a variety of AI technologies such as "teacher identity recognition", "face recognition" and "image intelligent recognition", Wenxiang has realized Program applications such as teacher height adaptive and speaker identity automatic recognition.'
      },
      {
        title: "New Automatic Tracking Mode",
        name:
          "The two tracking modes of group interaction and student listening behavior inspection are developed and designed according to the current popular group teaching mode, which can realize the automatic tracking and guidance of new teaching modes such as maker practice teaching, group class and future class."
      }
    ],

    featuresListTwo: [
      {
        title: "Simple Design",
        name:
          "Minimalist design supports wall-mounted installation, and does not take up classroom space."
      },
      {
        title: "All in one",
        name:
          "One normalized record and broadcasting equipment integrates the functions of multiple devices such as touch record and broadcasting host and remote interactive host, making the record and broadcasting device no longer be cumbersome."
      },
      {
        title: "High Performance and Ultra Stable",
        name:
          "The equipment adopts single-board design and built-in embedded system, supporting concurrent processing of multi-channel audio and video signals with strong performance, strong stability and durability."
      },
      {
        title: "4K Ultra HD Image Quality",
        name:
          "The camera uses 4K ultra-high-definition imaging technology, video analysis technology and electronic PTZ technology to make video shooting clearer and image tracking more accurate. And at the same time, it can achieve a single-dual scene, achieving 4 automatic tracking and switching by two cameras shoot, including teacher close-up and full view, student close-up and full view. The whole process without manual intervention provides a new recording experience and professional video effects."
      }
    ],

    featuresListThree: [
      {
        title: "Embedded Single-board Design",
        name:
          "Embedded single-board structure, and Linux system protect Windows from updates and viruses. The embedded architecture can also reduce the failure rate of the equipment. The power supply only needs 24V, which is low power consumption and low heat generation."
      },
      {
        title: "HD Audio Acquisition",
        name:
          "The audio signal of the instructor is picked up through the ceiling pickup microphone or collar microphone. The digital audio matrix processor performs noise reduction and audio equalization on the ambient sound to optimize the audio recording effect."
      },
      {
        title: "Easy and Automatic Operation",
        name:
          "With the control buttons on the micro-teaching panel, teachers can quickly start micro-teaching recording operations such as start, pause, pause, and live streaming. Once recording is completed, the video files can be automatically uploaded to the server with a single click, reducing redundant operations for teachers."
      },
      {
        title: "Online Video-editing",
        name:
          "Users can merge, edit and convert the video resources after login the resource management platform without downloading any client base. The edited videos can be uploaded to the resource management platform for sharing, which is convenient for students to learn."
      }
    ],

    featuresListFour: [
      {
        title: "3-minute Fast Installing",
        name:
          "Built-in embedded system can realize live streaming, on-demand and recording without plug-in. The whole installation of this system can be set up by simply selecting the location of the equipment and connecting the HD camera, portable record and broadcasting equipment, microphone and other accessories correctly. The whole system is easy to set up, which can be completed in 3 minutes, reducing the cumbersome operation steps and labor costs."
      },
      {
        title: "Portable and Easy Anytime and Anywhere",
        name:
          "The portable recording system is designed for temporary recording situations, with simple structure and easy movement. There is no need to set up a fixed recording classroom and it greatly saves the cost of users and realizes recording be finished at anywhere and anytime. The whole set of equipment can be easily carried by one person with designed fight case, and it is easy to move and record without any restrictions on location."
      },
      {
        title: "Guide Functions",
        name:
          "The guide function of the equipment is mainly used in the course of recording multiple scenes and multiple video signal sources, video/audio files and computer screen switching between."
      },
      {
        title: "Large Scale Live Streaming",
        name:
          "The device only needs to connect to the wireless network or mobile-phone hotspot. Then the program screen can be pushed to the whole network live streaming, and can automatically generate the live QR code, viewers can scan to watch the webcast."
      }
    ],

    featuresTwoList: [
      {
        title: "Remote Interaction",
        name:
          "It supports remote interaction and achieves cross-regional interactive teaching, visual network teaching and research and other remote interactive application mode."
      },
      {
        title: "Diversified Program Application Guide Management",
        name:
          "The equipment integrates video and audio acquisition, B/S web remote broadcasting, localized broadcasting, real-time recording, online live broadcasting, online on-demand, tracking and switching, equipment management and other Program application function, realizing simple operation and ensuring efficiency. In addition to computers, users can also log in to the platform through various mobile terminals, which breaks the restrictions of time and space."
      },
      {
        title: "Visual Educational Management",
        name:
          "The platform can carry out centralized control and unified management of each recording and broadcasting classroom, realizing equipment management, remote monitoring, online inspection, unsupervised examination and other Program applications. It provides visual teaching supervision and management platform for educational administrators."
      },
      {
        title: "Smart Docking Course Schedule",
        name:
          "Video automatically classified and stored, and resource management platform can be seamlessly connected with the school educational administration management system curriculum, which is easy to achieve automatic video release and archiving, forming a dynamic update of teaching resources."
      }
    ],

    featuresTwoListTwo: [
      {
        title: "Students",
        name:
          "It provides feedback on learning and carry out adaptive learning."
      },
      {
        title: "Teachers",
        name:
          "The system interface has been streamlined and optimized according to the actual use frequency of teachers, ensuring that teachers can easily get started like operating personal tablets, which ensures the accuracy of operation and let teachers focus on the teaching itself at the same time."
      },
      {
        title: "Audiovisual education administrator",
        name:
          "The product is highly integrated in design, making it easier to manage and maintain while reducing the failure rate."
      },
      {
        title: "School leaders",
        name:
          "It provides teaching information and data, comprehensively analyzes and scientifically grasp teaching status."
      }
    ],

    featuresThreeList: [
      {
        title: "Short",
        name:
          "The recording of high-quality micro-teaching video is generally produced for 5~8 minutes."
      },
      {
        title: "Small",
        name:
          "short time and small resource capacity ensure the quality of audio and video, and it is suitable for the dissemination and sharing of the mobile Internet era."
      },
      {
        title: "Precise",
        name:
          "The teaching content is concise, and it mainly highlights the essence of knowledge points."
      },
      {
        title: "Professional",
        name: "It has real-time and professional targeted knowledge points."
      }
    ],

    featuresFiveList: [
      {
        title: "Easy Operation",
        name:
          "The system is easy to operate and instructor do not have to change their original teaching habits."
      },
      {
        title: "Multi-point Interaction",
        name:
          "The system integrates multiple off-site classrooms into a teaching community, forming a cross-regional cloud classroom and achieving 1+N face-to-face online communication."
      },
      {
        title: "Smooth HD Experience",
        name:
          "The remote dual-teacher classroom solution uses new audio and video coding technology and supports a variety of interactive protocols to ensure that the audio and video interaction is clear and smooth."
      },
      {
        title: "Self-adapting to Complex Network",
        name:
          "It has advanced system algorithm, forward error correction(FEC) technology, frame loss compensation algorithm and Jitter buffering technology. Self-adaptive network and strong anti-packet loss capacity (more than 30%) guarantee low latency, clearness and smooth. And audio and video interaction effect is excellent. In the case of poor school network, the audio and video interaction can be carried out normally."
      },
      {
        title: "Real-time Analysis of Dual-teacher Classroom Data",
        name:
          "Comprehensive analysis of global data, including the number of online users and new users, the number of class sessions, classroom information (packet loss records/network latency records/network bandwidth/CPU utilization rate), etc. The platform analyzes the acquired data and presents it in a clear chart, which is easy for users to visualize and control."
      }
    ],

    featuresFiveListOne: [
      {
        title: "Easy Operation",
        name:
          "The system is easy to operate and instructor do not have to change their original teaching habits."
      },
      {
        title: "Multi-point Interaction",
        name:
          "The system integrates multiple off-site classrooms into a teaching community, forming a cross-regional cloud classroom and achieving 1+N face-to-face online communication."
      },
      {
        title: "Smooth HD Experience",
        name:
          "The remote dual-teacher classroom solution uses new audio and video coding technology and supports a variety of interactive protocols to ensure that the audio and video interaction is clear and smooth."
      },
      {
        title: "Self-adapting to Complex Network",
        name:
          "It has advanced system algorithm, forward error correction(FEC) technology, frame loss compensation algorithm and Jitter buffering technology. Self-adaptive network and strong anti-packet loss capacity (more than 30%) guarantee low latency, clearness and smooth. And audio and video interaction effect is excellent. In the case of poor school network, the audio and video interaction can be carried out normally."
      },
      {
        title: "Real-time Analysis of Dual-teacher Classroom Data",
        name:
          "Comprehensive analysis of global data, including the number of online users and new users, the number of class sessions, classroom information (packet loss records/network latency records/network bandwidth/CPU utilization rate), etc. The platform analyzes the acquired data and presents it in a clear chart, which is easy for users to visualize and control."
      }
    ],

    featuresFiveListTwo: [
      {
        title: "Network Courseware Production",
        name:
          "The system can automatically generate network courseware for network on-demand, which can be edited for deletion, synthesis, indexing, etc. It can also be imported into non-editing platform for professional editing. It is convenient for users to teach and learn comprehensive applications, high-quality courseware evaluation, etc."
      },
      {
        title: "Construction of High-quality Course Resource Library",
        name:
          "It can conduct a high-quality course resource library and provide an open management platform for schools to upload courseware."
      },
      {
        title: "Micro-teaching Assessment",
        name:
          "According to the needs of schools and the characteristics of micro-teaching, Wenxiang embeds the micro-teaching evaluation system in the recording system. Schools can evaluate the technical indicators in the system. And the content of the technical indicators can be modified according to the actual situation of the school. Objective and comprehensive evaluation of teachers' teaching skills can be reached through remote which can also train teachers various teaching skills and thus improve the teaching level."
      },
      {
        title: "Distance Learning Application",
        name:
          "Users can conduct live webcast and after-class on-demand, demonstration teaching, remote learning for students, and remote interactive teaching through the record and broadcasting system. Users can observe and learn at anytime and anywhere without any restriction."
      },
      {
        title: "Recording of Expert Lectures and Important Conferences",
        name:
          "Portable record and broadcasting system can truly realize all-round recording, which can record the whole process of various meetings, and the resources can be saved permanently, which can facilitate users to inquire and play the data after the meeting. The portable recording system is extremely suitable for various temporary meetings, lectures and training occasions."
      }
    ]
  },

  // 高教案例
  higherEdu: {
    title: "SMART CLASSROOM CONSTRUCTION PROGRAM (HIGHER EDUCATION)",
    content:"Wenxiang Smart Classroom is an innovative classroom with teaching services at its core. It is a set of solutions that achieves full media, full coverage, full linkage and interaction, covering all teaching aspects before, during and after class. It can optimize the presentation of teaching content, promote the implementation of classroom interaction and ease the convenience of access to teaching resources. It also have functions such as situational awareness and intelligent control of the environment, which realizing a new classroom teaching mode that is healthy, intelligent, environmentally friendly and efficient.",
    componentsTitle:'PROGRAM COMPONENTS',
    components:[
      'smart blackboard','electric smart lectern','recording system','learning behaviour analysis system','smart management','integrated design'
    ],
    features_title:'FEATURES AND ADVANTAGES',
    featuresList: [
      {
        title: "Smart Blackboard",
        name:
          "Wenxiang smart blackboard integrates traditional blackboard, intelligent teaching system, multi-touch, HD LCD display, amplifier, speaker and other technologies. Through the five-finger screen technology, teachers can easily switch seamlessly between the traditional blackboard and the interactive display system, complete ordinary blackboard writing, electronic whiteboard interaction, teaching resource invocation, multimedia courseware demonstration and other operations."
      },
      {
        title: "Eye Protection",
        name:
          "The glass surface of the Smart Blackboard uses a nano-composite coating process to filter out harmful light sources and effectively protect the eyesight of teachers and students."
      },
      {
        title: "Dual-system",
        name:
          "Windows and Android system platform enriches teaching applications."
      },
      {
        title: "Multimedia Teaching",
        name:
          "It comes with interactive whiteboard software and multimedia teaching resources, supporting various multimedia teaching materials such as video, music, pictures and PPT."
      }
    ],
    explanationList: [
      {
        title: "Intelligent Automatic 4K Recording",
        name:
          "The classroom contains a fully automatic six-camera recording system, which supports the filming and recording of multiple video channels, including teacher close-ups and full views, student close-ups and full views, writing close-ups and student patrol pictures. All shoots are in high quality, achieving true full HD recording. It also supports access to computer signals for recording. The student walk-through function allows you to take close-ups of each student in real time, forming student behaviour data for later analysis."
      },
      {
        title: "Group Interaction Teaching Brings Flipped Classroom",
        name:
          "It provides an open and free teaching space and information-based teaching tools for teachers and students, and it changes from teacher-centred to student-centred and achieves innovation and reform of teaching methods. Students can join group discussions quickly and independently in a active and great classroom where applications such as screen sharing, dynamic previews and dynamic annotations can be used to. Students will increase their learning interest and deepen knowledge understanding."
      }
    ],
    explanationTitle:'SMART MANAGEMENT',
    explanationFourList: [
      {
        title: "Smart Management System",
        name:
          "Smart Attendance: Based on deep learning algorithms, the system detects faces in images and performs a series of face-related feature analysis, recognizing multi-dimensional face information including name, position, clock-in time, expression and so on. The system can automatically generate attendance summary reports. For example, the number of people present, the number of people actually present, attendance statistics analysis, etc."
      },
      {
        title: "Intelligent learning analysis",
        name:
          "Intelligent learning analysis: The system supports AI technology and provides real-time insight into changes in the teaching scene. It can automatically capture and analyse the behavioral activities of students in the room, including the recognition of basic movements and combinations of movements such as head-down, hand-up, head-twist and turn-back, and automatically generate reports. For example: number of hands-raised, number of heads-down, statistical analysis, etc. Through the analysis of classroom student behavior, teachers can understand the learning status of students, improving the development of personalized teaching in schools from single to multiple, closed to open."
      },
      {
        title: "Smart Equipment Control",
        name:
          "The central control management platform provides remote control, information collection, data analysis, data monitoring, data statistics and fault alarm functions."
      },
      {
        title: "Centralized Management and Statistical Analysis",
        name:
          "Through the Wenxiang Data Platform, the operating status of information equipment in many classrooms can be visually checked and analyzed, including checking multimedia teaching equipment, recording equipment and other information equipment, and visualizing and managing data such as the number of times the equipment is used, the length of time it is used and the area in which it is distributed. "
      }
    ],
    controlSystemsTitle: 'SMART ENVIRONMENT CONTROL SYSTEM',
    controlSystem:[
      {
        name:"Smart Eye-protection Light Environment Control System: In order to comprehensively strengthen the prevention and control of myopia in teenagers, the light environment control system will recognize the light changes in the space and automatically adjust the power of the equipment to ensure that the system runs in the best state and ensure that teachers and students have classes in the healthiest light environment."
      },
      {
        name:"Smart Temperature and Humidity Control System: Based on the real measurements of the environment and the set target parameters, the air conditioning or fan operation is automatically adjusted to control the temperature and humidity of the environment, ensuring a healthy and comfortable environment in the classroom at all times."
      },
      {
        name:"Smart Air Quality Control System: The system is mainly composed of CO2 intelligent sensing module, PM2.5/PM10 intelligent sensing module, intelligent cabinet fresh air system and environmental intelligent control terminal, etc. The system solves all aspects of air quality problems in the classroom to ensure the air quality."
      }
    ]
  },
  // 常态化录播
  normalizedRecord:{
    title:"NORMALIZED RECORD AND BROADCASTING CLASSROOM CONSTRUCTION PROGRAM",
    content:"The program supports the construction of teaching video resources by means of information technology, realizes large-scale cross-platform interaction, live broadcasting, on-demand and other Program applications. And it has centralized management, remote control, online course patrol and other functions, enhancing the utilization rate and coverage of information teaching equipment. It also can help schools to carry out teaching work such as making teaching video courses, evaluating teachers' teaching ability, remote observation, comments and academic exchanges, teaching research and helping and assisting teaching, which can let more excellent teaching resources be made and shared together.",
    componentsTitle:'PROGRAM COMPONENTS',
    components: ['smart blackboard','normalized record and <br/>broadcasting equipment','teacher’s <br/>cloud mirror camera','student’s <br/>cloud Mirror camera','omnidirectional pickup','resource management <br/> platform'],
    features_title:'FEATURES AND ADVANTAGES',
    featuresList:[
      {
        title:'Simple Design',
        name:'Minimalist design supports wall-mounted installation, and does not take up classroom space.',
      },
      {
        title:'All in one',
        name:'One normalized record and broadcasting equipment integrates the functions of multiple devices such as touch record and broadcasting host and remote interactive host, making the record and broadcasting device no longer be cumbersome.',
      },
      {
        title:'High Performance and Ultra Stable',
        name:'The equipment adopts single-board design and built-in embedded system, supporting concurrent processing of multi-channel audio and video signals with strong performance, strong stability and durability.',
      },
      {
        title:'4K Ultra HD Image Quality',
        name:'The camera uses 4K ultra-high-definition imaging technology, video analysis technology and electronic PTZ technology to make video shooting clearer and image tracking more accurate. And at the same time, it can achieve a single-dual scene, achieving 4 automatic tracking and switching by two cameras shoot, including teacher close-up and full view, student close-up and full view. The whole process without manual intervention provides a new recording experience and professional video effects.',
      },
    ],
    easeOfUse:{
      title:'Ease of Use',
      name:'Ease of use is comprehensive and multi-layered. It can be segmented into user roles for a perfect experience.'
    },
    texts:[
      {name:'Teachers: The system interface has been streamlined and optimized according to the actual use frequency of teachers, ensuring that teachers can easily get started like operating personal tablets, which ensures the accuracy of operation and let teachers focus on the teaching itself at the same time.'},
      {name:'Students: It provides feedback on learning and carry out adaptive learning.'},
      {name:'Audiovisual education administrator: The product is highly integrated in design, making it easier to manage and maintain while reducing the failure rate.'},
      {name:'It provides teaching information and data, comprehensively analyzes and scientifically grasp teaching status.'},
    ]
  },
  // 4k精品录播
  record4k:{
    title:"4K RECORD AND BROADCASTING CLASSROOM CONSTRUCTION PROGRAM",
    content:"The 4K record and broadcasting classroom is built for recording high-quality courses, which can well reflect the unique teaching methods and advanced education concepts of the teachers. The system adopts multi-camera shooting to intelligently track and switch the video images of teachers teaching, students listening to lectures, teacher-student interaction scenes and classroom blackboard content. It is effective and necessary to create and disseminate excellent courses by recording classroom activities.",
    componentsTitle:'PROGRAM COMPONENTS',
    components: [
      'smart blackboard',
      'broadcasting <br/> equipment',
      'image tracking <br/> all-in-one equipment',
      'HD camera',
      'directional <br/> microphone ',
      'desktop touch panel',
      'resource management <br/> platform',
      'digital audio processor'
    ],
    features_title:'FEATURES AND ADVANTAGES',
    featuresList:[
      {
        title:'Safe and Stable',
        name:'All core devices are all adopts built-in DSP+ARM design based on Linux system, which has the characteristic of high stability, low consumption and maintenance-free.',
      },
      {
        title:'Fully Automated Operation',
        name:'It supports automatic image tracking and screen switching, which lets the teacher focus on the teaching itself. The teacher can start classroom recording by "one-click". HD shooting, and professional audio acquisition and processing helps the entire teaching process for HD recording.',
      },
      {
        title:'AI Technology',
        name:'Based on a variety of AI technologies such as "teacher identity recognition", "face recognition" and "image intelligent recognition", Wenxiang has realized Program applications such as teacher height adaptive and speaker identity automatic recognition.',
      },
      {
        title:'New Automatic Tracking Mode',
        name:'The two tracking modes of group interaction and student listening behavior inspection are developed and designed according to the current popular group teaching mode, which can realize the automatic tracking and guidance of new teaching modes such as maker practice teaching, group class and future class. ',
      },
      {
        title:'Remote Interaction',
        name:'It supports remote interaction and achieves cross-regional interactive teaching, visual network teaching and research and other remote interactive application mode.',
      },
      {
        title:'Diversified Program Application Guide Management',
        name:'The equipment integrates video and audio acquisition, B/S web remote broadcasting, localized broadcasting, real-time recording, online live broadcasting, online on-demand, tracking and switching, equipment management and other Program application function, realizing simple operation and ensuring efficiency. In addition to computers, users can also log in to the platform through various mobile terminals, which breaks the restrictions of time and space.',
      },
      {
        title:'Visual Educational Management',
        name:'The platform can carry out centralized control and unified management of each recording and broadcasting classroom, realizing equipment management, remote monitoring, online inspection, unsupervised examination and other Program applications. It provides visual teaching supervision and management platform for educational administrators.',
      },
      {
        title:'Smart Docking Course Schedule',
        name:'Video automatically classified and stored, and resource management platform can be seamlessly connected with the school educational administration management system curriculum, which is easy to achieve automatic video release and archiving, forming a dynamic update of teaching resources.',
      },
    ],
  },
  // 双师课堂
  dualTeacher:{
    title:"REMOTE DUAL-TEACHER CLASSROOM CONSTRUCTION PROGRAM ",
    content:"At present, China is comprehensively promoting Internet+education mode, relying on the advantages of the Internet and other information technology, innovating school twinning support mechanism, and promoting the common construction and sharing of high-quality educational resources, to expand the radiation of high-quality educational resources, and realize the management of mutual aid schools, teaching and research, resource sharing, information sharing, teacher-student interaction, and complementary differences. At the mode, there are two teachers. One lecturer teacher teaches online, the other teacher manages students on site in the classroom on the listening side offline. This teaching mode gives full play to the advantages of both online and offline teachers and effectively improve the classroom efficiency and teaching quality, enabling students from different regions to enjoy the same quality education resources. Now, the remote dual-teacher classroom solution has been well received by schools and training institutions. ",
    componentsTitle:'PROGRAM COMPONENTS',
    components: [
      'smart blackboard',
      'normalized record and <br/> broadcasting equipment',
      'teacher’s <br/> cloud Mirror camera ',
      'student’s <br/> cloud Mirror camera ',
      '4k record and <br/> broadcasting<br/> equipment',
      'directional <br/> microphone ',
      'resource management <br/> platform',
    ],
    features_title:'FEATURES AND ADVANTAGES',
    featuresList:[
      {
        title:'Multi-point Interaction',
        name:'The system integrates multiple off-site classrooms into a teaching community, forming a cross-regional cloud classroom and achieving 1+N face-to-face online communication.',
      },
      {
        title:'Smooth HD Experience',
        name:'The remote dual-teacher classroom solution uses new audio and video coding technology and supports a variety of interactive protocols to ensure that the audio and video interaction is clear and smooth.',
      },
      {
        title:'Self-adapting to Complex Network',
        name:'It has advanced system algorithm, forward error correction(FEC) technology, frame loss compensation algorithm and Jitter buffering technology. Self-adaptive network and strong anti-packet loss capacity (more than 30%) guarantee low latency, clearness and smooth. And audio and video interaction effect is excellent. In the case of poor school network, the audio and video interaction can be carried out normally.',
      },
      {
        title:'Real-time Analysis of Dual-teacher Classroom Data',
        name:'Comprehensive analysis of global data, including the number of online users and new users, the number of class sessions, classroom information (packet loss records/network latency records/network bandwidth/CPU utilization rate), etc. The platform analyzes the acquired data and presents it in a clear chart, which is easy for users to visualize and control.',
      },
    ],
  },
  // AI 行为分析
  aiAnslysis:{
    title: "AI INTELLIGENT BEHAVIOR ANALYSIS MANAGEMENT PLATFORM ",
    content:"Wenxiang Behavior Analysis System supports artificial intelligence technology and it can automatically capture and analyze the behavior of teachers and students through the intelligent behavior analysis box , and automatically generate reports, such as: the number of hands raised and heads down, the proportion of emotion statistical analysis, etc., to analyze the behavior of classroom teachers and students, understand the status of students on learning. <br/> Through artificial intelligence and big data personalized and accurate analysis, the system can help the development of personalized teaching in schools. The basic information management of the school and student behavior related data are collected, and stored digitally, which provides important resources for the construction of intelligent school.",
    features_title:'FEATURES AND ADVANTAGES',
    featuresList: [
      {
        title: "support one-click import the curriculum",
        name:''
      },
      {
        title: "focus on the real-time teaching scene",
        name:''
      },
      {
        title: "various visual charts",
        name:''
      },
      {
        title: "intelligent statistical analysis",
        name:''
      },
      {
        title: "INTELLIGENT BEHAVIOR ANALYSIS BOX",
        name:''
      },
      {
        title: "Noiseless",
        name:'Embedded ARM architecture with fan-less design ensures no noise in use.'
      },
      {
        title: "Network Video Access",
        name:'Supports no less than 2 network video stream access to realize the real-time analysis of teachers and students.'
      },
      {
        title: "Support scene analysis",
        name:'Supports PTZ tour and it can be configured in the box to adapt to the scene analysis.'
      },
      {
        title: "Support Local Output",
        name:'HDMI supports local output to view the analysis screen and the screen marks real-time analysis results.'
      },
      {
        title: "Standard Interface",
        name:'Adopts 1 Mbps Ethernet port and standard HTTP interface can connect with the school information system.'
      },
      {
        title: "Safe Power Supply",
        name:'The box adopts 12V safe power supply.'
      }
    ],
  },
  // 便携录播
  portableRecord:{
    title:"PORTABLE RECORD AND BROADCASTING CONSTRUCTION PROGRAM",
    content:"The rapid development of the Internet, AI, big data, 5G and other technologies has brought significant impact on education and teaching. Wenxiang is actively applying new information technology to innovate teaching organization mode, improve learning environment, develop digital education resources, accelerate the construction and application of intelligent learning environment, enhance the innovative ability of informationized teaching, and promote the deep integration of information technology and teaching. Based on this, Wenxiang launched a portable record and broadcasting construction solution, which adopts full wireless transmission technology and can be set up in 3 minutes, so that recording and broadcasting can be truly mobile and no longer restricted by the site environment. It realizes high-quality course resource production and relay, academic video presentation and conference, large-scale live streaming of course video, and distance education, and etc.",
    componentsTitle:'PROGRAM COMPONENTS',
    components: [
      'portable record and <br/> broadcasting equipment',
      'cloud mirror camera',
      'monopod sets',
      'wireless omnidirectional mic',
      'public webcasting',
      'online vod',
    ],
    features_title:'FEATURES AND ADVANTAGES',
    featuresList:[
      {
        title:'3-minute Fast Installing',
        name:'Built-in embedded system can realize live streaming, on-demand and recording without plug-in. The whole installation of this system can be set up by simply selecting the location of the equipment and connecting the HD camera, portable record and broadcasting equipment, microphone and other accessories correctly. The whole system is easy to set up, which can be completed in 3 minutes, reducing the cumbersome operation steps and labor costs.',
      },
      {
        title:'Portable and Easy Anytime and Anywhere',
        name:'The portable recording system is designed for temporary recording situations, with simple structure and easy movement. There is no need to set up a fixed recording classroom and it greatly saves the cost of users and realizes recording be finished at anywhere and anytime. The whole set of equipment can be easily carried by one person with designed fight case, and it is easy to move and record without any restrictions on location.',
      },
      {
        title:'Guide Functions',
        name:'The guide function of the equipment is mainly used in the course of recording multiple scenes and multiple video signal sources, video/audio files and computer screen switching between. ',
      },
      {
        title:'Large Scale Live Streaming',
        name:'The device only needs to connect to the wireless network or mobile-phone hotspot. Then the program screen can be pushed to the whole network live streaming, and can automatically generate the live QR code, viewers can scan to watch the webcast. ',
      },
    ],
  },
  // 历届展会
  exhibitions:{
    "feature":[
      // {
      //   img:'ISE-2024.png',
      //   info:`BUNKA exhibits at Europe's largest AV integration event, Integrated<br/>
      //   Systems Europe (ISE) , 30 Jan - 2 Feb 2024<br/>
      //   BUNKA is pleased to announce that it will be exhibiting at Europe's largest <br/>
      //   AV integration event, ISE 2024 - Integrated Systems Europe.<br/>
      //   We will present a wide range of products and systems, including recording <br/>
      //   and broadcasting equipment, intelligent blackboards and touch displays.<br/>
      //   We look forward to seeing you at our booth!<br/>
      //   Booth #4H530<br/>
      //   Invitation Code:6HSCBNVI<br/>
      //   For more information on ISE 2024, please visit<br/>
      //   https://www.iseurope.org/ise-2024-conference-programme`
      // },
      {
        img:'/static/exhibition/2025-spain.png',
        info:`ISE 2025<br/>
          Barcelona, Spain   4-7 Feb, 2025<br/>
          Booth: 1B600<br/>
          ISE 2025 (Integrated Systems Europe 2025) is one of the most authoritative and influential professional exhibitions in the global audio-visual industry and also the largest exhibition for audio-visual and systems integration in the world. It serves as a barometer for the development of industry technology and is an important platform for global audio-visual companies to showcase their latest products, technologies, and solutions. During the exhibition, participants can not only witness the latest technological innovations but also gain in-depth insights into industry trends and future development directions through seminars, forums, and product demonstrations. Moreover, ISE 2025 provides valuable opportunities for communication between exhibitors and visitors, promoting business cooperation and knowledge sharing on a global scale.
          `
      },
      {
        img:'/static/exhibition/2024-dubai.png',
        info:`GESS Dubai <br/>
              Dubai, UAE  Nov 12-14, 2024<br/>
              Booth: F10<br/>

              GESS Dubai exhibition is fully backed by the UAE Ministry of Education. It has grown to become the most significant and authoritative education show in the Middle East, an essential event for industry professionals in the region's educational equipment sector. WenTech launched its new 2024 lineup at the show, including interactive smart displays and AI recording solutions, drawing much attention.  WenTech introduces its cutting-edge Interactive Smart Panels and IBB(Intelligent BlackBoard) series, praised for their performance, technology, and customization. Available in various sizes and configurations, these devices are designed to fit any setting and provide a seamless experience.
              `
      },
      {
        img:'/static/exhibition/2024-thailand.png',
        info:`InfoComm Asia <br/>
          Bangkok, Thailand  July 17-19, 2024  <br/>
          Booth: Hall 4 C10 <br/>

          InfoComm Asia is the premier professional audio-visual and integrated experience technology exhibition in the Asia-Pacific region, focusing on showcasing Pro-AV technologies, innovative solutions, and best practices in the industry. At InfoComm Asia 2024, WenTech's AI Portable Recording product and IBB (Intelligent BlackBoard) series garnered significant attention from end-users due to their innovative technologies and powerful functionalities. These products not only demonstrated WenTech's cutting-edge capabilities in the field of educational technology but also provided more efficient and convenient solutions for educational settings.`
      },
      {
        img:'/static/exhibition/2024-las-vagas.png',
        info:`InfoComm USA<br/>
          Las Vegas, Nevada  June 12-14, 2024<br/>
          Booth: 8578<br/>
          Invitation Code: WEN344<br/>

          WenTech launched its 2024 lineup featuring advanced products like interactive smart displays and AI recording solutions. These innovations highlight WenTech's robust tech prowess and deep understanding of educational and business needs. Designed for intuitive and efficient communication, WenTech products enhance interactions in meetings, classrooms, and remote collaborations. WenTech leverages cutting-edge technologies to deliver smarter and more convenient products and solutions to users.
          `
      },
      {
        img:'/static/exhibition/2024-tokyo.png',
        info:`EDIX Tokyo (15th EDUCATION EXPO JAPAN)<br/>
            Tokyo, Japan  May 8-10, 2024<br/>
            Booth: 21-48<br/>

            Making its debut in the Japanese market, BUNKA showcased an educational equipment series that integrates multicultural elements with innovative design. This series includes the education recording and broadcasting system, memory sliding blackboards, and a variety of large-screen solutions. Thanks to their innovation and practicality, these products attracted significant attention from numerous agents and end-users, making the on-site experience area extremely popular.
            `
      },
    ],
    "previous":[]

  },
  news:{
    title:'news',
    list:[
      {
        "id": "2025-ISE-Exhibition",
        "time": "2025.2.4",
        "tag": "event",
        "title": "2025 ISE Exhibition: WenTech AI Product Series Empowers All-Scenario Smart Ecosystem",
        "contents": [
          {
              "type": "html",
              "content": "From February 4th to 7th, 2025, the world's largest and most influential audiovisual and systems integration exhibition, the 2025 ISE Exhibition, was held at the Fira de Barcelona International Exhibition Center in Spain. The event brought together top technology companies and industry experts from around the globe to explore the latest trends and innovative applications in audiovisual technology. As a pioneer in the industry, WenTech made a stunning appearance with a series of cutting-edge technology products and solutions, capturing the attention of numerous visitors."
          },
          {
            "type": "img",
            "content": "2025-ISE-1.png"
          },
          {
            "type":"html",
            "content":"<b>AI Recording Solutions: Versatile Recording for Every Need</b>"
          },
          {
            "type": "img",
            "content": "2025-ISE-2.png"
          },
          {
            "type": "img",
            "content": "2025-ISE-3.png"
          },
          {
            "type":"html",
            "content":"In the realm of recording solutions, WenTech's AI portable recording, classroom recording, and practical training recording solutions garnered significant attention. The AI portable recording solution, leveraging artificial intelligence and portability, allows users to capture high-quality audio and video content anytime, anywhere, providing a convenient and efficient tool for educational training, personal events, and corporate activities."
          },
          {
            "type": "img",
            "content": "2025-ISE-4.png"
          },
          {
            "type": "html",
            "content": "The classroom recording solution focuses on education and training, automatically recording classroom lectures and training sessions for later review and learning, enhancing the effectiveness of teaching and training, and providing robust support for the accumulation and sharing of educational resources."
          },
          {
            "type": "img",
            "content": "2025-ISE-5.png"
          },
          {
            "type": "html",
            "content": "The practical training recording solution is designed for professional training scenarios such as medical surgery training and industrial skills practice, accurately capturing every detail of the training process, offering strong support for teaching evaluation, vocational training, and skill enhancement."
          },
          {
            "type": "html",
            "content": "<b>Professional Touch Displays: Meeting Diverse Scenario Needs</b>"
          },
          {
            "type": "img",
            "content": "2025-ISE-6.png"
          },
          {
            "type": "html",
            "content": "WenTech's professional, diverse, and multi-size touch displays became a focal point at the exhibition. Equipped with the latest Android 14 system and integrated with the AI Google EDLA solution, these screens deliver an unprecedented intelligent experience. The displays feature built-in AI functions such as text recognition, which quickly and accurately extracts text information from the screen, facilitating editing and processing. The AI-generated questionnaire function significantly simplifies market research and teaching evaluation workflows, earning high praise from customers. These features not only showcase WenTech's leading position in AI technology applications but also effectively meet the diverse needs of users across various industries. Additionally, WenTech's smart panels come in multiple sizes and offer various functional solutions, providing personalized options to suit different scenarios."
          },
          {
            "type": "img",
            "content": "2025-ISE-7.png"
          },
          {
            "type": "img",
            "content": "2025-ISE-8.png"
          },
          {
            "type": "img",
            "content": "2025-ISE-9.png"
          },
          {
            "type": "img",
            "content": "2025-ISE-10.png"
          },
          {
            "type": "html",
            "content": " WenTech also showcased products such as the portable smart screen with built-in power and the electric lift stand, further enriching user scenarios."
          },
          {
            "type": "html",
            "content": "<b>Smart Whiteboard: Fusion of Innovation, Revolutionizing Teaching Experience</b>"
          },
          {
            "type": "img",
            "content": "2025-ISE-11.png"
          },
          {
            "type": "html",
            "content": "The smart whiteboard, a core exhibit, combines traditional and modern technologies, featuring advanced touch control and high-definition display, enabling multimedia interactive teaching and intelligent handwriting recognition, bringing a new experience to teaching. Leveraging its strong R&D capabilities, WenTech has developed customized foldable memory whiteboards for different educational scenarios. These whiteboards, combined with WenTech's self-developed writing software, effectively address many pain points in university teaching. For example, the foldable design increases the display area, allowing teachers to present multiple teaching materials simultaneously; the memory function automatically saves written content, enabling teachers and students to review key knowledge at any time. This innovative product has been highly praised by university teachers and students."
          },
          {
            "type": "html",
            "content": "<b>Highly Integrated Lectern: Convenient Teaching Experience</b>"
          },
          {
            "type": "img",
            "content": "2025-ISE-12.png"
          },
          {
            "type": "html",
            "content": "The highly integrated lectern displayed at the exhibition also attracted significant attention. This lectern features a dual-screen design, offering quick and convenient operation. The main screen is used to display presentation slides or documents, ensuring accurate information delivery with clear visuals and smooth performance; the secondary screen provides background privacy operations, allowing teachers to switch content, such as teaching videos or experimental materials, without affecting the main screen display, greatly enhancing teaching convenience and flexibility. Additionally, the lectern is equipped with an electric lift function, allowing height adjustment based on the user's needs, and the screen angle can be freely adjusted, providing a more comfortable teaching environment."
          },
          {
            "type": "img",
            "content": "2025-ISE-13.png"
          },
          {
            "type": "html",
            "content": "<b>IOT System Integration: Building Smart Classrooms</b>"
          },
          {
            "type": "img",
            "content": "2025-ISE-14.png"
          },
          {
            "type": "html",
            "content": "WenTech's IOT system integrates classroom control systems, enabling centralized control of large screen switches, signal switching, recording device control, lighting, and curtains within a single IOT system. WenTech's IOT system integration brings intelligent management to the classroom. Through this system, teachers can centrally control large screen switches, signal switching, recording device operation, and even manage classroom lighting and curtains. This integrated control method not only simplifies operational processes and improves teaching preparation efficiency but also creates a smart and convenient classroom environment."
          },
          {
            "type": "img",
            "content": "2025-ISE-15.png"
          },
          {
            "type": "html",
            "content": "WenTech achieved excellent results at the exhibition, signing annual strategic cooperation agreements with two major clients on-site, with plans for in-depth collaboration post-exhibition. The products displayed attracted a large number of visitors who stopped to experience them, and the professional technical team provided detailed presentations and services. Numerous educational institutions, corporate representatives, and experts gave high praise, recognizing the products' advantages in functionality, design, and user experience, bringing new ideas to teaching, work, and learning."
          },
          {
            "type": "html",
            "content": "At this opening exhibition of the year, WenTech officially announced the launch of its new brand------WEONEX. This move marks a significant upgrade in the company's brand strategy, aiming to further expand the market, meet the increasingly diverse needs of consumers, and inject new momentum into the company's long-term development."
          },
          {
            "type": "html",
            "content": "WenTech's impressive display at the 2025 ISE Exhibition fully demonstrated its strong capabilities and innovative prowess in the audiovisual and educational technology fields, further solidifying its leading position in the industry. The exhibition not only showcased WenTech's strength in audiovisual and educational technology but also provided an opportunity to interact with global industry elites and drive innovation in the educational technology sector. Through interactions and exchanges with various stakeholders, WenTech will further expand its international market and continue to bring more technologically advanced products and services to global users."
          }
        ]
      },
      {
        id:'Belt-and-Road-Educational-Equipment-Conference',
        time:'2024.12.20',
        tag:'event',
        title:"WenTech Diversifies Innovations at the 'Belt and Road' Educational Equipment Conference in Fuzhou",
        contents:[
          {
            type:'html',
            content:"To actively respond to General Secretary Xi Jinping's important speech at the opening ceremony of the Third Belt and Road Forum for International Cooperation, and to deepen exchanges and cooperation among Belt and Road countries in the field of educational equipment, the Belt and Road International Educational Equipment Innovation and Development Conference was held in Fuzhou on 20-22 December. This conference was hosted by the China Educational Equipment Industry Association and focused on the innovation and development of educational equipment. It attracted many experts, scholars and enterprise representatives from home and abroad to gather and jointly discuss the future trends of educational equipment. Ms. Miao, General Manager of the Overseas Business Department of WenTech, delivered a wonderful speech at the main forum, sharing the innovative achievements of Chinese educational equipment and its internationalization process. In addition, WenTech exhibited the most cutting-edge educational equipment products at this exhibition, demonstrating our technical strength and innovation ability. Meanwhile, we also provided exclusive recording and live streaming services for the conference, ensuring the wide dissemination and efficient communication of the conference content.",
          },
          {
            type:'img',
            content:'b-r-1.jpg'
          },
          {
            type:'html',
            content:'The opening ceremony commenced promptly at 9 a.m., with distinguished guests including Jin Nuo, President of the China Education Equipment Industry Association; Ye Xun, Secretary of the Fujian Provincial Education Work Committee, Head of the Secretariat of the Fujian Provincial Education Work Leading Group, and Secretary of the Party Committee and Director of the Fujian Provincial Department of Education; Anulon Vilaiporn, Dean of the Laos Institute of Educational Sciences; Li Jian, Education and Cultural Counselor at the Indonesian Embassy in China; and Steve Miller, Vice Chairman of the World Skills Development Alliance, among other domestic and international leaders and experts. The ceremony was chaired by Li Ying, Secretary-General of the China Education Equipment Industry Association.'
          },
          {
            type:'img',
            content:'b-r-2.jpg'
          },
          {
            type:'img',
            content:'b-r-3.jpg'
          },
          {
            type:'html',
            content:'At the opening ceremony, Ye Xun, the leading official from the Fujian Provincial Education Work Committee and Director of the Fujian Provincial Department of Education, along with Xia Guoming, Vice President of the China Education Equipment Industry Association, warmly congratulated the convening of the conference. They highlighted the crucial role of innovation in educational equipment in propelling the modernization of education.'
          },
          {
            type:'img',
            content:'b-r-4.jpg'
          },
          {
            type:'img',
            content:'b-r-5.jpg'
          },
          {
            type:'html',
            content:'Session I of the keynote speeches, themed "International Perspective," was chaired by Xia Yue, Vice President of the China Education Equipment Industry Association. Anulon Vilaiporn, Dean of the Laos Institute of Educational Sciences, and Li Jian, Education and Cultural Counselor at the Indonesian Embassy in China, successively shared their insights, showcasing the educational development strategies of Laos and Indonesia. Steve Miller, Vice Chairman of the World Skills Development Alliance and Chief Expert on the European Qualifications Framework, discussed "Future Educational Equipment: Curriculum Standard Development Led by the European Qualifications Framework," offering an international outlook on the future curriculum standards for educational equipment.'
          },
          {
            type:'img',
            content:'b-r-6.jpg'
          },
          {
            type:'html',
            content:'Session II of the keynote speeches, focusing on the innovative development of educational equipment, was conducted under the leadership of Shi Jianguo, Deputy Director of the Educational Equipment Research Institute of the China Education Equipment Industry Association. Zhu Shunzhi, Vice President of Xiamen University of Technology, Shu Peidong, a member of the Party Group and Deputy Director of the Zhejiang Provincial Department of Education, and Wang Fang, Principal of Shanghai Qibao Dwight High School, shared their insights from perspectives including AI technology innovation practice, the Belt and Road policy, and the implementation of educational technology. They discussed the innovation and application of educational equipment in various scenarios.'
          },
          {
            type:'img',
            content:'b-r-7.jpg'
          },
          {
            type:'html',
            content:"During the keynote speeches, Ms. Miao, General Manager of WenTech's Overseas Business Division, presented on the topic \"Innovation and Integration of Chinese Educational Equipment Abroad.\" Ms. Miao highlighted that the vigorous promotion of educational internationalization and the \"Belt and Road\" initiative have created unparalleled opportunities for the international expansion of educational equipment. These policy frameworks have opened up extensive international market spaces and collaborative platforms for domestic educational equipment enterprises, incentivizing them to explore overseas markets actively. Under such favorable policies, WenTech has leveraged its years of experience in the educational equipment sector to initiate an ambitious overseas expansion. She noted that WenTech's products and services have been successfully implemented in over 20 countries globally, including Thailand, Russia, the European Union, the United Arab Emirates, India, Singapore, the United States, Japan, and Malaysia, where they are extensively used in practical teaching environments."
          },
          {
            type:'img',
            content:'b-r-8.jpg'
          },
          {
            type:'html',
            content:'During the initial phase of international expansion, WenTech faced numerous challenges, including educational system disparities, technical standard differences, and market entry barriers. Undeterred, Wentech Team conducted thorough research to tailor their products to local demands. For regions with poor internet infrastructure, they strengthened the offline storage and user-friendliness of their AI-powered recording devices to ensure smooth educational content capture. In high-standard markets like Europe and America, they enhanced data security and product compatibility to comply with rigorous regulations. Looking to the future, Ms. Miao is confident that WenTech will leverage favorable policies to deepen its global presence and expand its business reach. WenTech is committed to collaborating with international partners, sharing technology, and engaging in localized R&D to develop customized equipment for diverse educational settings. They aim to establish a platform for connecting educational resources across borders, promoting equitable education development worldwide, and making quality education accessible to all.'
          },
          {
            type:'img',
            content:'b-r-9.jpg'
          },
          {
            type:'html',
            content:'During the conference, WenTech showcased a range of forward-looking products and comprehensive solutions, such as AI analysis and portable AI recording devices. These innovative exhibits, built on advanced technology and integrated with unique application models, attracted many attendees to stop and take a closer look. They have injected new vitality into the intelligent evolution of educational equipment and set a new benchmark.'
          },
          {
            type:'img',
            content:'b-r-10.jpg'
          },
          {
            type:'html',
            content:"Additionally, WenTech provided recording and live streaming services for the conference using its AI-powered portable recording equipment. With state-of-the-art technology and a team of seasoned professionals, WenTech ensured that every engaging discussion and highlight moment of the conference was captured with precision and smoothness. This allowed educators unable to attend in person to experience the intellectual exchange of the conference in real-time, ensuring that the meeting's information was fully preserved, laying a solid foundation for future communication, learning, and research."
          },
          {
            type:'img',
            content:'b-r-11.jpg'
          },
          {
            type:'html',
            content:'The successful hosting of the "Belt and Road" International Conference on the Innovation and Development of Educational Equipment has showcased the courage and remarkable achievements of Chinese enterprises in advancing education. It is believed that with the collective effort of all, and with the momentum of this conference, the standard of educational equipment in "Belt and Road" countries will steadily reach new heights. In the future, colleagues in the global educational equipment field will also take this gathering as a new starting point to continue deep cooperation, allowing the innovation of educational equipment to spread like a prairie fire across every corner of international education.'
          }
        ]
      },
      {
        "id": "Dubai-2024",
        "time": "2024.11.14",
        "tag": "event",
        "title": "WenTech Ignites Dubai GESS: Where Chinese Tech Meets Global Aspirations",
        "contents": [
          {
              "type": "html",
              "content": "From November 12-14, 2024, GESS Dubai at the Dubai World Trade Centre showcased the latest in educational technology, drawing top players and professionals from around the globe. WenTech, having made waves in Europe, the Americas, and Asia, now brings its innovative solutions to the Middle East, showcasing its prowess in edtech to the region."
          },
          {
              "type": "img",
              "content": "Dubai-1.png"
          },
          {
              "type": "html",
              "content": "Annually held and organized by Worlddidac, the GESS Dubai exhibition is fully backed by the UAE Ministry of Education. It has grown to become the most significant and authoritative education show in the Middle East, an essential event for industry professionals in the region's educational equipment sector."
          },
          {
              "type": "img",
              "content": "Dubai-2.png"
          },
          {
              "type": "html",
              "content": "WenTech launched its new 2024 lineup at the show, including interactive smart displays and AI recording solutions, drawing much attention. These products showcase WenTech's tech strength and its grasp of educational and business needs. Aimed at enhancing communication, WenTech's offerings promise intuitive and efficient interaction in various settings, from meetings to remote work."
          },
          {
              "type": "img",
              "content": "Dubai-3.png"
          },
          {
              "type": "img",
              "content": "Dubai-4.png"
          },
          {
              "type": "html",
              "content": "WenTech introduces its cutting-edge Interactive Smart Panels and IBB(Intelligent BlackBoard) series, praised for their performance, technology, and customization. Available in various sizes and configurations, these devices are designed to fit any setting and provide a seamless experience. With optional accessories like cameras and visualizers, they're versatile for remote teaching, in-class learning, and business presentations, addressing a wide array of requirements. "
          },
          {
              "type": "img",
              "content": "Dubai-5.png"
          },
          {
              "type": "img",
              "content": "Dubai-6.png"
          },
          {
              "type": "html",
              "content": 'At the exhibition, WenTech unveiled its latest AI-powered recording solutions, encompassing 4K portable recording, 4K class-room recording, and 4K mobile training solutions.    Nova Mohammed Wajid from a prominent Dubai ICT corporation remarked, "These solutions are poised to transform education in the Middle East, presenting new business opportunities. We look forward to exploring extensive future collaborations."    Tailored for Middle Eastern educational institutions and individual users, these solutions offer a variety of recording options to meet diverse teaching requirements. They are versatile, fitting the needs of schools, corporate training, and remote education alike.'
          },
          {
            "type": "img",
            "content": "Dubai-7.png"
          },
          {
            "type": "img",
            "content": "Dubai-8.png"
          },
          {
            "type": "img",
            "content": "Dubai-9.png"
          },
          {
            "type": "html",
            "content": "At the event, WenTech's team conducted live demonstrations and interactive sessions, giving attendees a direct taste of the superior performance and innovative features of their products. Numerous clients from the Middle East were impressed, noting that WenTech's technology was a breath of fresh air, and they anticipate deepening their partnership with WenTech in the future."
          },
          {
            "type": "img",
            "content": "Dubai-10.png"
          },
          {
            "type": "html",
            "content": "During the event, WenTech welcomed a distinguished visitor, Mr. Fan Ding, the Education Counsellor from the Chinese Embassy in the UAE, to their booth. Displaying a strong interest in WenTech's offerings, Counsellor Fan Ding praised the company's contributions to educational technology innovation. He highlighted the significance of Chinese enterprises' advancements in this field for enhancing China-UAE educational ties and encouraged WenTech to continue driving innovation and product development to strengthen these partnerships further."
          },
          {
            "type": "img",
            "content": "Dubai-11.png"
          },
          {
            "type": "html",
            "content": 'A spokesperson from WenTech stated that their participation in the exhibition not only demonstrated their innovative capabilities in educational technology but also paved the way for further expansion into the Middle East market. In the future, WenTech intends to align with the "Belt and Road" initiative, deepen its "going global" strategy, and expand into overseas markets through an integrated approach of production, sales, and research, continuing to pursue a path of global development.'
          },
          {
            "type": "html",
            "content": "The Dubai GESS show serves as a vital platform for international collaboration in edtech. WenTech's involvement has highlighted their innovative edge and energized the global edtech landscape. Looking ahead, WenTech is poised to continue its innovative leadership, propelling the growth and prosperity of educational technology on a global scale."
          }
        ]
      },
      {
        id:'news-infocomm-2024',
        time:'2024.6.24',
        tag:'event',
        title:'WenTech Stuns at InfoComm 2024',
        contents:[
          {
            type:'html',
            content:'Recently, WenTech successfully captured global attention with its new solutions and products at InfoComm USA 2024, held grandly in Las Vegas, USA, becoming a highlight of the exhibition.'
          },
          {
            type:'img',
            content:'infocomm-2024-1.png'
          },
          {
            type:'img',
            content:'infocomm-2024-2.png'
          },
          {
            type:'html',
            content:"At the expo, WenTech launched its 2024 lineup featuring advanced products like interactive smart displays and AI recording solutions. These innovations highlight WenTech's robust tech prowess and deep understanding of educational and business needs. Designed for intuitive and efficient communication, WenTech products enhance interactions in meetings, classrooms, and remote collaborations."
          },
          {
            type:'img',
            content:'infocomm-2024-3.png'
          },
          {
            type:'html',
            content:"WenTech leverages cutting-edge technologies such as artificial intelligence to deliver smarter and more convenient products and solutions to users. These offerings enhance both work efficiency and overall user experience. With a diverse product line, WenTech offers customized services tailored to individual customer needs in education, business, and beyond."
          },
          {
            type:'img',
            content:'infocomm-2024-4.png'
          },
          {
            type:'html',
            content:"Against the backdrop of global digital and intelligent transformation, WenTech remains committed to monitoring market trends and meeting user demands. We will drive advancements in smart interactive display technology through continuous technological innovation and product refinement.At the same time, WenTech will deepen AI recording development, tailor applications to local needs, and enhance office, educational, and entertainment uses.WenTech will also continue expanding into international markets to deliver higher-quality products and services to global users."
          },
          {
            type:'img',
            content:'infocomm-2024-5.png'
          },
          {
            type:'html',
            content:"WenTech’s remarkable debut at InfoComm 2024 in the USA promises enhanced user experiences globally. In the future, WenTech will continue collaborating with global users to explore further possibilities in smart interaction and AI recording and broadcasting system."
          },
        ],
      },
      {
        id:'news-ise-2024',
        time:'2024.1.30',
        tag:'event',
        title:'Debut of BUNKA Shines on ISE 2024',
        contents:[
          {
            type:'html',
            content:'Integrated System Europe (ISE) 2024 kicked off in Barcelona, Spain on January 30. In this exhibition, Bunka, a subsidiary of WenXiang, gained the attention of the industry with its cutting-edge technology products. The exhibition covers screen display products, intelligent recording and broadcasting series solutions, smart lectern and other accessories, perfect applications and rich usage scenarios, which has become a highlight of the exhibition.'
          },
          {
            type:'img',
            content:'ise-2024-1.png'
          },
          {
            type:'html',
            content:"ISE exhibition is the world's largest and most influential professional audiovisual and system integration technology exhibition, attracting industry elites from all over the world every year. On such a stage, Bunka Technology with its profound technical accumulation and keen market insight brings a visual feast of technology to the global audience."
          },
          {
            type:'img',
            content:'ise-2024-2.png'
          },
          {
            type:'html',
            content:"Bunka shows its Touch Display and Intelligent Blackboard, both of which utilize  3588 motherboard and the latest Android system, and attracts widespread attention for their high degree of integration and convenient operation. Touch Display perfectly integrates HD display, audio processing, computing core and rich application software, providing customers with a new interactive experience. Meanwhile, it also provides high-precision multi-level recognition, prevents accidental touch in the actual operation process and greatly improves the operating experience. Users can write and annotate directly on the screen, realizing instant display and communication of multimedia content, and greatly enhancing the interactivity and teaching efficiency in the classroom."
          },
          {
            type:'img',
            content:'ise-2024-3.png'
          },
          {
            type:'html',
            content:"Meanwhile, the first show of Bunka Intelligent Blackboard also attracts the attention of many audiences. This intelligent blackboard not only has the traditional function, but also incorporates advanced touch technology and cloud computing platform. Users can easily realize the operation of touch, drag and drop, zoom and so on like using cell phones. And at the same time, the contents can also be saved in real time and shared. The emergence of smart blackboards will undoubtedly bring a more intelligent and efficient teaching model to the education industry."
          },
          {
            type:'img',
            content:'ise-2024-4.png'
          },
          {
            type:'html',
            content:"In addition to the above two products, Bunka Technology also demonstrates its newly upgraded Portable Recording and Broadcasting Solution. With 4K image quality and full-wireless connection technology, it can quickly realize HD and smooth video recording, live broadcasting, interaction and other function, whether it is used for online teaching, remote training, or for meeting records, live events."
          },
          {
            type:'img',
            content:'ise-2024-5.png'
          },
          {
            type:'html',
            content:"The Practical Training Recording and Broadcasting also attracts a lot of attention. With full-angle shooting and universal arm, this product can support HD and fine-tuning shooting, which can be applied to a variety of vocational education and training scenarios, such as surgical demonstration, art carving, cooking cuisine, automotive maintenance, hairdressing, etc..  The movable trolley as a carrier and audio and video equipment as a supplement can make deep integration of theory and  actual operation, letting information technology serve the cultivation of talents in the new era."
          },
          {
            type:'img',
            content:'ise-2024-6.png'
          },
          {
            type:'html',
            content:"The Bunka also brings 4K and normalized recording and broadcasting solution. These solutions adopt advanced video coding technology and cloud computing storage technology, and contain AI modules, which can propose differentiated solutions according to the different needs of customers in behavioral analysis, face recognition, resource recording, live events, remote interaction, etc., so that customers can get the ultimate user experience."
          },
          {
            type:'img',
            content:'ise-2024-7.png'
          },
          {
            type:'html',
            content:"In order to better realize the intelligent management of teaching scenes, Bunka also brought the latest smart lectern. Its highly integration of intelligent control system, video recording system, interactive system, tracking system and audio processing system realizes convenient operation  and  intelligent teaching application."
          },
          {
            type:'html',
            content:"On the site, Bunka Technology attracts many visitors stop to experience. Many visiting guests and industry analysts spoke highly of Bunka's products. Bunka said that in the future, it will continue to plunge into the field of science and technology, and constantly explore and develop more innovative products that meet the market demand and lead the industry trend."
          },
          {
            type:'html',
            content:"With the successful conclusion of ISE 2024, Bunka Technology's new products have also gained full of praises and expectations. In the future, we have reason to believe that Bunka Technology will continue to lead the innovation and development of education technology with its outstanding products and solutions, creating a better learning and living experience for users around the world."
          },
        ],
      },
    ]
  },
  backToMainMenu:'Back to Main Menu',
  product2025:{
    "PT-Series-Touch-Display":{
      title:"PT Series Touch Display",
      corverImg:"/static/images/detail/PT-Series/corver.png",
      imgList:[
        {imgUrl: "/static/images/detail/PT-Series/1.jpg"},
        {imgUrl: "/static/images/detail/PT-Series/2.jpg"},
        {imgUrl: "/static/images/detail/PT-Series/3.jpg"},
        {imgUrl: "/static/images/detail/PT-Series/4.jpg"},
        {imgUrl: "/static/images/detail/PT-Series/5.jpg"},
        {imgUrl: "/static/images/detail/PT-Series/6.jpg"},
        {imgUrl: "/static/images/detail/PT-Series/7.jpg"},
        {imgUrl: "/static/images/detail/PT-Series/8.jpg"},
        {imgUrl: "/static/images/detail/PT-Series/9.jpg"},
        {imgUrl: "/static/images/detail/PT-Series/10.jpg"},
        {imgUrl: "/static/images/detail/PT-Series/11.jpg"},
      ]
    },
    "IBB-F01-IR-Series-Intelligent-Blackboard":{
      title:"IBB-F01  IR Series Intelligent Blackboard",
      corverImg:"/static/images/detail/IBB-F01/corver.png",
      imgList:[
        {imgUrl: "/static/images/detail/IBB-F01/1.jpg"},
        {imgUrl: "/static/images/detail/IBB-F01/2.jpg"},
        {imgUrl: "/static/images/detail/IBB-F01/3.jpg"},
        {imgUrl: "/static/images/detail/IBB-F01/4.jpg"},
        {imgUrl: "/static/images/detail/IBB-F01/5.jpg"},
        {imgUrl: "/static/images/detail/IBB-F01/6.jpg"},
        {imgUrl: "/static/images/detail/IBB-F01/7.jpg"},
      ],
    },
    "IBB-P02-Series-Intelligent-Blackboard":{
      title:"IBB-P02 Series Intelligent Blackboard",
      corverImg:"/static/images/detail/IBB-P02/corver.png",
      imgList:[
        {imgUrl: "/static/images/detail/IBB-P02/1.jpg"},
        {imgUrl: "/static/images/detail/IBB-P02/2.jpg"},
        {imgUrl: "/static/images/detail/IBB-P02/3.jpg"},
        {imgUrl: "/static/images/detail/IBB-P02/4.jpg"},
        {imgUrl: "/static/images/detail/IBB-P02/5.jpg"},
      ],
    },
    "RS05-SERIES-IR-Premium-Touch-Display":{
      title:"RS05 SERIES  IR Premium Touch Display",
      corverImg:"/static/images/detail/RS05/corver.png",
      imgList:[
        {imgUrl: "/static/images/detail/RS05/1.jpg"},
        {imgUrl: "/static/images/detail/RS05/2.jpg"},
        {imgUrl: "/static/images/detail/RS05/3.jpg"},
        {imgUrl: "/static/images/detail/RS05/4.jpg"},
        {imgUrl: "/static/images/detail/RS05/5.jpg"},
        {imgUrl: "/static/images/detail/RS05/6.jpg"},
        {imgUrl: "/static/images/detail/RS05/7.jpg"},
        {imgUrl: "/static/images/detail/RS05/8.jpg"},
        {imgUrl: "/static/images/detail/RS05/9.jpg"},
        {imgUrl: "/static/images/detail/RS05/10.jpg"},
        {imgUrl: "/static/images/detail/RS05/11.jpg"},
      ]
    },
    "RS02-Series-NEW-EDLA-Touch-Display":{
      title:"RS02 Series  NEW EDLA Touch Display",
      corverImg:"/static/images/detail/RS02/corver.png",
      imgList:[
        {imgUrl: "/static/images/detail/RS02/1.jpg"},
        {imgUrl: "/static/images/detail/RS02/2.jpg"},
        {imgUrl: "/static/images/detail/RS02/3.jpg"},
        {imgUrl: "/static/images/detail/RS02/4.jpg"},
        {imgUrl: "/static/images/detail/RS02/5.jpg"},
        {imgUrl: "/static/images/detail/RS02/6.jpg"},
        {imgUrl: "/static/images/detail/RS02/7.jpg"},
      ]
    },
    "RS03-Series-AI-Integrated-IR-Touch-Display":{
      title:"RS03 Series AI Integrated IR Touch Display",
      corverImg:"/static/images/detail/RS03/corver.png",
      imgList:[
        {imgUrl: "/static/images/detail/RS03/1.jpg"},
        {imgUrl: "/static/images/detail/RS03/2.jpg"},
        {imgUrl: "/static/images/detail/RS03/3.jpg"},
        {imgUrl: "/static/images/detail/RS03/4.jpg"},
        {imgUrl: "/static/images/detail/RS03/5.jpg"},
        {imgUrl: "/static/images/detail/RS03/6.jpg"},
        {imgUrl: "/static/images/detail/RS03/7.jpg"},
        {imgUrl: "/static/images/detail/RS03/8.jpg"},
        {imgUrl: "/static/images/detail/RS03/9.jpg"},
        {imgUrl: "/static/images/detail/RS03/10.jpg"},
      ]
    },
    "RS01-Series-Education-IR-Touch-Display":{
      title:"Interactive Education Display",
      corverImg:"/static/images/detail/RS01/corver.png",
      imgList:[
        {imgUrl: "/static/images/detail/RS01/1.jpg"},
        {imgUrl: "/static/images/detail/RS01/2.jpg"},
        {imgUrl: "/static/images/detail/RS01/3.jpg"},
        {imgUrl: "/static/images/detail/RS01/4.jpg"},
        {imgUrl: "/static/images/detail/RS01/5.jpg"},
        {imgUrl: "/static/images/detail/RS01/6.jpg"},
        {imgUrl: "/static/images/detail/RS01/7.jpg"},
      ]
    },
    "Smart-Mobile-Screen":{
      title:"Smart Mobile Screen ",
      corverImg:"/static/images/detail/Smart-Mobile-Screen/corver.png",
      imgList:[
        {imgUrl: "/static/images/detail/Smart-Mobile-Screen/1.jpg"},
        {imgUrl: "/static/images/detail/Smart-Mobile-Screen/2.jpg"},
        {imgUrl: "/static/images/detail/Smart-Mobile-Screen/3.jpg"},
        {imgUrl: "/static/images/detail/Smart-Mobile-Screen/4.jpg"},
        {imgUrl: "/static/images/detail/Smart-Mobile-Screen/5.jpg"},
      ]
    },
    "WT-01-Series":{
      title:"Smart Mobile Screen ",
      corverImg:"/static/images/detail/WT-01-Series/corver.png",
      imgList:[
        {imgUrl: "/static/images/detail/WT-01-Series/1.jpg"},
        {imgUrl: "/static/images/detail/WT-01-Series/2.jpg"},
        {imgUrl: "/static/images/detail/WT-01-Series/3.jpg"},
      ]
    },
    "WT-05-Series":{
      title:"WT-05 Series Electric Smart Lectern",
      corverImg:"/static/images/detail/WT-05-Series/corver.png",
      imgList:[
        {imgUrl: "/static/images/detail/WT-05-Series/1.jpg"},
        {imgUrl: "/static/images/detail/WT-05-Series/2.jpg"},
      ]
    },
    "W-R04-Series-Practical-Training-Recording-and-Broadcasting-Solution":{
      title:"W-R04 Series Practical Training Recording and Broadcasting Solution",
      corverImg:"/static/images/detail/W-R04-Series/corver.png",
      imgList:[
        {imgUrl: "/static/images/detail/W-R04-Series/1.jpg"},
        {imgUrl: "/static/images/detail/W-R04-Series/2.jpg"},
        {imgUrl: "/static/images/detail/W-R04-Series/3.jpg"},
        {imgUrl: "/static/images/detail/W-R04-Series/4.jpg"},
      ]
    },
    "W-R03-Series-4K-Premium-Recording-and-Broadcasting-Solution":{
      title:"W-R03 Series 4K Premium Recording and Broadcasting Solution",
      corverImg:"/static/images/detail/W-R03-Series/corver.png",
      imgList:[
        {imgUrl: "/static/images/detail/W-R03-Series/1.jpg"},
        {imgUrl: "/static/images/detail/W-R03-Series/2.jpg"},
        {imgUrl: "/static/images/detail/W-R03-Series/3.jpg"},
      ]
    },
    "W-R02-Series-Classroom-Recording-and-Broadcasting-Solution":{
      title:" Classroom Recording and Broadcasting Solution",
      corverImg:"/static/images/detail/W-R02-Series/corver.png",
      imgList:[
        {imgUrl: "/static/images/detail/W-R02-Series/1.png"},
        {imgUrl: "/static/images/detail/W-R02-Series/2.png"},
        {imgUrl: "/static/images/detail/W-R02-Series/3.png"},
        {imgUrl: "/static/images/detail/W-R02-Series/4.png"},
        {imgUrl: "/static/images/detail/W-R02-Series/5.png"},
        {imgUrl: "/static/images/detail/W-R02-Series/6.png"},
      ]
    },
    "W-R01-Series-Portable-Recording-and-Broadcasting-Solution":{
      title:"W-R01 Series Portable Recording and Broadcasting Solution ",
      corverImg:"/static/images/detail/W-R01-Series/corver.png",
      imgList:[
        {imgUrl: "/static/images/detail/W-R01-Series/1.png"},
        {imgUrl: "/static/images/detail/W-R01-Series/2.png"},
        {imgUrl: "/static/images/detail/W-R01-Series/3.png"},
        {imgUrl: "/static/images/detail/W-R01-Series/4.png"},
        {imgUrl: "/static/images/detail/W-R01-Series/5.png"},
        {imgUrl: "/static/images/detail/W-R01-Series/6.png"},
        {imgUrl: "/static/images/detail/W-R01-Series/7.png"},
        {imgUrl: "/static/images/detail/W-R01-Series/8.png"},
        {imgUrl: "/static/images/detail/W-R01-Series/9.png"},
        {imgUrl: "/static/images/detail/W-R01-Series/10.png"},
        {imgUrl: "/static/images/detail/W-R01-Series/11.png"},
      ]
    },
    "Supporting-Solutions":{
      title:"Supporting Solutions",
      corverImg:"",
      imgList:[
        {imgUrl: "/static/images/detail/Supporting-Solutions/1.jpg"},
        {imgUrl: "/static/images/detail/Supporting-Solutions/2.jpg"},
        {imgUrl: "/static/images/detail/Supporting-Solutions/3.jpg"},
      ]
    }
  }
};



// WEBPACK FOOTER //
// ./src/langs/en.js